{
  "app": {
    "title": "Local UI",
    "langs": {
      "en": "English"
    }
  },
  "drawer": {
    "links": {
      "nodes": "Nodes",
      "view": "View",
      "update": "Update",
      "updateLog": "Update log",
      "workloads": "Workloads",
      "labels": "Labels",
      "remotes": "Remotes",
      "notifications": "Notifications",
      "deploy": "Deploy",
      "deployment": "Deployment",
      "access": "Access",
      "users": "Users",
      "roles": "Roles",
      "ldap": "LDAP",
      "registry": "Registry",
      "system": "System",
      "availableUpdates": "Updates",
      "usageReports": "Usage reports",
      "logs": "Logs",
      "about": "About"
    },
    "version": "Version",
    "systemInfo": "System info",
    "updateAvailable": "New update for Management system is available"
  },
  "footer": {
    "facebook": "Facebook",
    "footer": "Footer",
    "github": "Github",
    "twitter": "Twitter"
  },
  "toast": {
    "text": "Operation successfully executed.",
    "closeBtn": "Close"
  },
  "errorDialog": {
    "title": "Error",
    "text": "There was some unexpected error.",
    "interfacesText": "The following interfaces failed to configure:",
    "okBtn": "OK"
  },
  "interfaceDialog": {
    "title": "Network interface configuration",
    "text": "You have not set an IP address of the network interface you're currently accessing from, so to access this page again you have to manually replace the address in the URL with the newest one."
  },
  "dialog": {
    "yes": "Yes",
    "cancel": "Cancel",
    "ok": "OK",
    "continue": "Continue",
    "close": "Close",
    "doNotShowDialogAgainMessage": "Don't ask me again"
  },
  "loadingBar": {
    "text": "Please wait"
  },
  "toolbar": {
    "menus": {
      "documentation": "Documentation",
      "downloadConnectionManager": "Download Nerve Connection Manager",
      "userSettings": "Settings",
      "logout": "Log Out"
    },
    "pageTitles": {
      "nodes": {
        "view": "View nodes",
        "add": "Add node",
        "edit": "Edit node",
        "workloadControl": "View deployed workload control",
        "update": {
          "view": "View node updates",
          "log": "View node update logs",
          "details": "View node update details"
        }
      },
      "workloads": {
        "view": "View workloads",
        "add": "Add workload",
        "edit": "Edit workload",
        "versions": {
          "add": "Add workload version",
          "edit": "Edit workload version",
          "clone": "Clone workload version"
        }
      },
      "deploy": {
        "deployment": "Workload deployment",
        "log": "View workload deployment logs",
        "details": "View workload deployment details"
      },
      "labels": {
        "view": "View labels",
        "merge": "Merge labels",
        "add": "Add label",
        "edit": "Edit label"
      },
      "access": {
        "users": {
          "view": "View users",
          "add": "Add user",
          "edit": "Edit user",
          "settings": "Edit user settings"
        },
        "roles": {
          "view": "View roles",
          "add": "Add role",
          "edit": "Edit role"
        },
        "ldap": "LDAP"
      },
      "remotes": "View active remote connections",
      "notifications": {
          "view": "View notifications",
          "add": "Add notification",
          "edit": "Edit notification"
      },
      "registry": "View docker registry",
      "system": {
        "update": "View system update",
        "usageReports": "View usage reports",
        "logs": "View system logs",
        "about": "About"

      },
      "downloads": "Downloads"
    }
  },
  "defaultTable": {
    "search": "Search",
    "rowsPerPage": "Rows per page:",
    "Delete": "Delete",
    "Disable": "Disable",
    "Enable": "Enable",
    "Clone": "Clone",
    "Import": "Import",
    "Export": "Export",
    "Export_in-progress": "Export is in progress",
    "Export_failed": "Export has failed",
    "Deploy": "Deploy",
    "Update": "Replace",
    "Copy": "Use as template",
    "CancelCreation": "Cancel creation",
    "DisabledCancelCreation": "Cancel creation",
    "Retry": "Retry",
    "DisabledRetry": "Retry",
    "Feedback": "Feedback",
    "DisabledFeedback": "Feedback",
    "MarkTaskAsFail": "Mark task as fail",
    "MarkTaskAsSuccess": "Mark task as success",
    "MarkTaskAsFinish": "Mark task as finish",
    "DisabledMarkTaskAsFail": "Mark task as fail",
    "DisabledMarkTaskAsSuccess": "Mark task as success",
    "DisabledMarkTaskAsFinish": "Mark task as finish",
    "Restore": "Restore",
    "applyConfiguration": "Apply configuration",
    "logs": "Logs",
    "logsDisabled": "Docker workload logs are disabled. Enable them in node settings.",
    "start": "Start container",
    "pause": "Pause container",
    "stop": "Stop container",
    "restart": "Restart container",
    "Import_initiated": "Import in progress",
    "Import_backup_download_in_progress": "Import in progress",
    "Import_backup_extraction_in_progress": "Import in progress",
    "Import_completed": "Data successfully imported",
    "Export_initiated": "Export in progress",
    "Export_backup_creation_in_progress": "Export in progress",
    "Export_backup_upload_in_progress": "Export in progress",
    "cancel": "Cancel not possible",
    "cancelExport": "Cancel export",
    "cancelImport": "Cancel import",
    "Export_completed": "Export successfully completed",
    "loadingText": "Loading {tableData}...",
    "workloadsLoadingVariable": "workloads",
    "versionsLoadingVariable": "workload versions",
    "searchWorkloads": "Search workloads...",
    "searchVersions": "Search versions...",
    "searchNodes": "Search nodes...",
    "searchConnections": "Search connections...",
    "searchDeployments": "Search deployments...",
    "searchUpdates": "Search updates...",
    "searchLabels": "Search labels...",
    "searchGroups": "Search groups...",
    "searchUsers": "Search users...",
    "searchVolumes": "Search volumes...",
    "searchPermissions": "Search permissions...",
    "searchRoles": "Search roles...",
    "searchReports": "Search reports...",
    "searchNotifications": "Search notifications...",
    "searchMinChars": "Enter at least 2 characters to search.",
    "resultsSummaryWithEntity": "Showing {shown} of {total} {entity}",
    "summaryEntity": {
      "result": "result",
      "results": "results",
      "node": "node",
      "nodes": "nodes",
      "permission": "permission",
      "permissions": "permissions",
      "token": "token",
      "tokens": "tokens"
    },
    "options": "Options",
    "Connect": "Establish connection",
    "connections": "Connections",
    "connectionsDialogTitle": "Connections for service {serviceName}",
    "connectionsEmptyList": "No connections available."
  },
  "baseForm": {
    "saveBtn": "Save",
    "cancelBtn": "Cancel",
    "required": "This field is required",
    "passwordRequiredMsg": "Password is required",
    "passwordMinLengthMsg": "Password must be more than {msgLength} characters long",
    "passwordMaxLengthMsg": "Password must be less than {msgLength} characters long",
    "updateBtn": "Update",
    "back": "Back",
    "next": "Next",
    "add": "Add",
    "discardChangesBtn": "Discard changes",
    "reApply": "Re-apply {dnaType} DNA configuration",
    "applyConfiguration": "Apply {dnaType} DNA configuration"
  },
  "globals": {
    "remove": "DELETE",
    "add": "ADD",
    "edit": "EDIT",
    "cpu": "CPU",
    "cpuUsage": "CPU usage",
    "units": {
      "tb": "TB",
      "gb": "GB",
      "mb": "MB"
    },
    "connect": "Connect",
    "logs": "Logs",
    "month": "Month",
    "year": "Year"
  },
  "downloads": {
    "pageTitle": "Nerve Connection Manager (NCM)",
    "windowsInstaller": "Windows Installer",
    "linuxPackage": "Linux Package",
    "noFilesAvailable": "Nerve Connection Manager apps not available."
  },
  "login": {
    "formTitle": "Sign In",
    "labelUsername": "Username",
    "labelPassword": "Password",
    "fieldIsRequired": "This field is required",
    "formValidateLength": "Password must be less than 45 characters",
    "formValidateValid": "Username must be valid",
    "loginBtn": "Sign in",
    "welcomeBack": "Welcome back",
    "welcomeSubtitle": "Sign in to your account to continue",
    "emailLabel": "Email address",
    "forgotPasswordLink": "Forgot password?",
    "or": "or",
    "needHelp": "Need help?",
    "contact": "Contact",
    "contactSuffix": "your system administrator.",
    "wrongCredentials": "Invalid username or password!",
    "notLoggedIn": "You are not logged in.",
    "emailRegexMsg": "Invalid email.",
    "passwordExpirationMessage": "Your password will expire in {days} days. Please change it.",
    "passwordExpirationTodayMessage": "Your password will expire today. Please change it.",
    "resetPassword": {
      "title": "Reset password",
      "newPass": "New Password*",
      "confirmPass": "Confirm Password*",
      "requiredRule": "Required",
      "compareRule": "Passwords do not match",
      "resetBtn": "Reset",
      "invalidLink": "Invalid reset password link, please request a new one.",
      "changedPassword": "Successfully changed password"
    },
    "activateProfile": {
      "title": "Set new password",
      "newPassField": "New Password*",
      "confirmPassField": "Confirm Password*",
      "requiredRule": "Required",
      "compareRule": "Passwords do not match",
      "saveBtn": "Save",
      "profileAlreadyExist": "This profile is already activated or does not exist.",
      "setNewPassMsg": "Set new password and activate account.",
      "passwordIsChanged": "Password is changed successfully and profile is activated",
      "alreadyLoggedIn": "You are already logged in to the application. To activate a new user, please log out first."
    },
    "activateMFA": {
      "title": "Use QR code for two-factor authentication",
      "userManualLink": "For more information see",
      "userManual": "User Manual",
      "confirmBtn": "Complete setup",
      "mfaActivated": "MFA is activated successfully.",
      "mfaReset": "MFA is reset successfully."
    },
    "validateMFA": {
      "title": "Provide authentication code",
      "totpRegexMsg": "Invalid authentication code.",
      "totpInputHint": "6-digit code generated by your authenticator app.",
      "confirmBtn": "Confirm",
      "notLoggedIn": "Please enter your login credentials first."
    },
    "forgotPassword": {
      "title": "Reset credentials",
      "emailField": "Email address*",
      "requiredRule": "This field is required",
      "emailRegexMsg": "Invalid email!",
      "note": "Please enter a valid email address associated with this Management System.",
      "resetBtn": "Reset",
      "emailInstructionsSent": "If an account exists for the provided email address, instructions to reset your credentials will be sent shortly.",
      "cancelBtn": "Cancel"
    }
  },
  "users": {
    "userSettings": "User settings",
    "list": {
      "addUser": "Add User",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "created": "Created",
      "type": "Type",
      "userRoles": "User Roles",
      "emptyState": "No user was found",
      "userType": "User type",
      "removeSubTitle": "Are you sure you want to delete this user?",
      "deleteConfirm": "Delete user",
      "deletedItem": "User successfully deleted",
      "all": "All",
      "local": "Local",
      "ldap": "Ldap"
    },
    "addEditUser": {
      "loadingImage": "Loading image",
      "uploadDragAndDropImage": "Click or drag and drop image here",
      "firstName": "First name",
      "lastName": "Last name",
      "username": "Username/email",
      "emailHint": "Email has to be a valid one because it is used for activation.",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "language": "Language",
      "role": "Role",
      "changePasswordTitle": "Change password",
      "enterPasswordMsg": "Please enter your new password",
      "oldPasswordLbl": "Old password",
      "newPasswordLbl": "New password",
      "confirmNewPasswordLbl": "Confirm new password",
      "oldPasswordErrorMsg": "Your old password was entered incorrectly. Please enter it again.",
      "newPasswordHint": "Your password needs to contain at least {requireUppercase} {requireLowercase} {requireNumbers} {requireSpecialChars} and length should be between {minLength} and {maxLength} characters",
      "passwordRegexMsg": "Your password needs to contain at least {requireUppercase} {requireLowercase} {requireNumbers} {requireSpecialChars} and length should be between {minLength} and {maxLength} characters",
      "passwordRegexMsgWithoutPp": "Password must be between {minLength} and {maxLength} characters long.",
      "newPasswordHintWithoutPp": "Password must be between {minLength} and {maxLength} characters long.",
      "uppercase": "1 uppercase letter,",
      "lowercase": "1 lowercase letter,",
      "numbers": "1 number,",
      "specialChars": "1 special character",
      "passwordMatchMsg": "Passwords must match!",
      "emailRegexMsg": "Invalid email!",
      "nameRegexMsg": "Invalid name!",
      "noWhitespaceAtTheBeginningMsg": "Invalid name! Name cannot start with whitespace character.",
      "nameMinLengthMsg": "Name must consist of minimum 2 letters!",
      "wrongImgExtensionMsg": "Only .jpeg, .jpg and .png file types are allowed.",
      "maxImgSizeExceededMsg": "Maximum file size of 5 MB is exceeded!",
      "roleRequiredMsg": "At least one role is required.",
      "usrName": "Username",
      "email": "Email",
      "successUpdate": "User successfully updated.",
      "successUpdateRole": "User successfully updated. For the changes to take effect, sign out and sign in again.",
      "successCreate": "User successfully created",
      "roleUpdatedToast": "Your role has been updated, please refresh the browser page to see the changes.",
      "mfa": "Multi-factor Authentication",
      "mfaDisabled": "Disabled",
      "mfaEnabled": "Enabled",
      "newPasswordSameAsCurrentMsg": "New password cannot be the same as the current password.",
      "profileTab": "Profile",
      "tokensTab": "Access tokens"
    },
    "accessTokens" : {
      "addAccessToken": "Add access token",
      "searchTokens": "Search tokens...",
      "searchPermissions": "Search permissions...",
      "tokenName": "Name",
      "tokenNameRequired": "Name*",
      "permissions": "Permissions",
      "createdDate": "Created",
      "lastUsed": "Last used",
      "status": "Status",
      "none": "None",
      "never": "Never",
      "neverUsed": "Never used",
      "permissionsCount": "{count} permission | {count} permissions",
      "loading": "Loading access tokens...",
      "empty": "List of access tokens is empty.",
      "noResults": "No access tokens match the current filter criteria.",
      "copyAction": "Use as template",
      "revokeConfirm": "Revoke access token",
      "revokeSubTitle": "Are you sure you want to revoke this access token?",
      "revokeSuccess": "Access token successfully revoked.",
      "deleteConfirm": "Delete access token",
      "deleteSubTitle": "Are you sure you want to delete this access token?",
      "deleteSuccess": "Access token successfully deleted.",
      "statusValues": {
        "active": "Active",
        "revoked": "Revoked",
        "expired": "Expired"
      },
      "createNewTokenBtn": "Create token",
      "generateAccessToken": "Create access token",
      "viewAccessToken": "View access token details",
      "required": "Required",
      "tokenNameMinMax": "Token name must be between {minLength} and {maxLength} characters long",
      "noControlCharacter": "Control characters are not allowed.",
      "tokenNameExists": "An access token with this name already exists.",
      "selectAtLeastOnePermission": "At least one permission needs to be selected.",
      "tokenExpiry": "Expiration date",
      "tokenPermissions": "Permissions",
      "permissionsSelected": "permission(s) selected",
      "loadingPermissions": "Loading user permissions...",
      "emptyPermissionsTable": "No permissions available for selected user.",
      "noResultsPermissionsTable": "No permissions match the search criteria.",
      "permissionsTable": {
        "empty": "No permissions available for selected user.",
        "noResults": "No permissions match the current filter criteria."
      },
      "filterSelected": "Selected",
      "filterUnselected": "Unselected",
      "selectionFilterTooltip": "Filter by selection",
      "tokenSecretTitle": "Token created",
      "tokenSecretCopy": "Copy to clipboard",
      "tokenSecretCopied": "Copied!",
      "copyTokenDetails": "Copy token details",
      "revokeToken": "Revoke token",
      "deleteToken": "Delete token",
      "apiKey": "API key",
      "created": "Created",
      "expires": "Expires",
      "saveApiKeyTitle": "Important: Save your API key",
      "saveApiKeyText": "This API key will only be displayed once. Copy and store it securely as it cannot be retrieved again.",
      "tokenRevokedSuccess": "Token successfully revoked",
      "tokenCopied": "API key copied to clipboard"
    }
  },
  "remoteConnection": {
    "title": "REMOTE CONNECTIONS",
    "titleNode": "Remote Connections",
    "addRemoteScreen": "Remote screen",
    "addRemoteTunnel": "Remote tunnel",
    "addRemoteScreenTooltip": "Add new Remote screen",
    "addRemoteTunnelTooltip": "Add new Remote tunnel",
    "export": "Export",
    "import": "Import",
    "exportTooltip": "Export Remote connections",
    "exportDisabledTooltipNode": "Unavailable during node creation.",
    "exportDisabledTooltipWorkload": "Unavailable during workload creation.",
    "exportDisabledTooltipNoRc": "Inactive when no remote connections are configured.",
    "importTooltip": "Import Remote connections",
    "importRcInfoMessage": "Click on Save to apply changes.",
    "portNumbersMessage": "Port must have a value between 0 and 65536.",
    "numberOfConnectionsLimitation": "Number of connections must have a value between 1 and 100.",
    "autoRetryLimitation": "Auto retry must have a value between 1 and 3.",
    "required": "Required",
    "rulesForInputField": "Maximum length is 40 characters.",
    "invalidPort": "Invalid port",
    "initConnectionTitle": "Connections for {nodeWl} {name}",
    "name": "Name",
    "type": "Type",
    "port": "Port",
    "serviceNameColumn": "Service",
    "approval": "Approval",
    "connectionTo": "Connection to {rc}",
    "connectingNote": "Note: If pop-up window for remote connection does not open after connection is approved, please check pop-up settings at address bar and try again.",
    "waitingForApproval": "Waiting for approval...",
    "waiting": "Waiting...",
    "approvalLinkText": "Connection is approved. If you lost the link, it's here:",
    "remoteConnectionDialogUrlLink": "Click me in order to run application",
    "expiresAt": "After the expiration time: {expiresAt}, the session will be closed.",
    "copyLink": "Copy link",
    "approvalLinkHref": "link",
    "managementToastFailedVersionMismatch": "Failed to establish connection, Node version is not compatible with ManagementSystem",
    "managementToastFailed": "Failed to establish connection.",
    "closeDialog": "Close",
    "guacamoleClientMsnConnectionRejected": "Connection rejected.",
    "guacamoleClientMsnConnectionDisconnected": "Connection disconnected.",
    "guacamoleClientMsnConnectionSessionExpired": "Connection session expired.",
    "guacamoleSessionExpired": "The session has expired, please connect again.",
    "guacamoleClientDisconectedTitle": "Disconnected",
    "rcNameContainControlCharacter": "Invalid name! Name cannot contain control character.",
    "rcNameContainOnlySpaces": "Invalid name! Name cannot contain only whitespaces.",
    "rcNameHostnamePattern": "Invalid hostname! Hostname must contain only numbers, letters, _, . and -",
    "ncmLinkExpired": "Connection link expired.",
    "dialog": {
      "name": "Name*",
      "newRemoteTunnel": "New remote tunnel",
      "editRemoteTunnel": "Edit remote tunnel",
      "newRemoteScreen": "New remote screen",
      "editRemoteScreen": "Edit remote screen",
      "nerveParameters": "NERVE PARAMETERS",
      "networkParameters": "NETWORK PARAMETERS",
      "hostname": "Hostname*",
      "vmHostname": "VM hostname / IP*",
      "portOnNode": "Port on node*",
      "portOnWorkload": "Port on workload*",
      "portOnPC": "Port on PC*",
      "yes": "Yes",
      "no": "No",
      "localAcknowledgment": "Local acknowledgment",
      "connectionType": "Connection type",
      "numbOfConnections": "Number of connections*",
      "autoretry": "Autoretry*",
      "displaySettings": "DISPLAY SETTINGS",
      "authentication": "AUTHENTICATION",
      "cursor": "Cursor",
      "swapRedBlue": "Swap red blue",
      "readOnly": "Read only",
      "VNCpassword": "Password*",
      "password": "Password",
      "username": "Username",
      "usernameRequired": "Username*",
      "connectionTypeVNC": "VNC",
      "connectionTypeSSH": "SSH",
      "connectionTypeRDP": "RDP",
      "privateKey": "Private key authentication",
      "privateHostKey": "Private host key",
      "successfullyDeleted": "Remote connection successfully deleted",
      "deleteConfirm": "Delete remote connection",
      "removeSubTitle": "Are you sure you want to delete [{name}] remote connection?",
      "ignoreServerCertificate": "Ignore Server Certificate",
      "successfullyAdded": "Remote connection successfully added",
      "successfullyUpdated": "Remote connection successfully updated",
      "successfullyRemoved": "Remote connection successfully removed",
      "successfullyImported": "Remote connection successfully imported",
      "detailDownloading": "Download in progress...",
      "reconnect": "Reconnect",
      "close": "Close",
      "errorTitle": "Error",
      "code:": "Error",
      "disconnected": "Disconnected",
      "disconnectedMessage": "You have been disconnected.",
      "code:769": "You have entered invalid credentials. Please reconnect and try again.",
      "code:519": "The server is currently unreachable. Please check connection from your and server side and try again.",
      "code:515": "The remote desktop server encountered an error and has closed the connection. Please try again.",
      "code:520": "The remote desktop server is currently unavailable. Please try again.",
      "code:797": "The number of concurrent connections has been exceeded. Please try again later.",
      "code:771": "You do not have permission to access this connection.",
      "code:516": "Resource not found",
      "code:512": "An internal error occurred, and the operation could not be completed. Possible causes include a terminated connection, an expired session, or exceeding the maximum number of concurrent connections.",
      "composeServices": "Service*"
    },
    "securityMode": {
      "title": "Security mode",
      "any": "ANY",
      "nla": "NLA (Network Level Authentication)",
      "rdp": "RDP encryption",
      "tls": "TLS encryption",
      "unspecified": "unspecified"
    },
    "cursor": {
      "local": "local",
      "remote": "remote",
      "unspecified": "unspecified"
    },
    "table": {
      "name": "Name",
      "service": "Service",
      "type": "Type",
      "port": "Port",
      "emptyList": "List is empty.",
      "rcNodeEmptyList": "No remote connections are configured for this node",
      "noResults": "No remote connections match the current filter criteria.",
      "loading": "Loading remote connections...",
      "rcWorkloadEmptyList": "No remote connections are configured for this workload",
      "rcContainerEmptyList": "No remote connections are configured for this container"
    },
    "passwordIsRequiredForVnc": "Remote connection passwords must be entered manually. A password is mandatory for VNC connections and for any screen connection with a username; the workload version cannot be saved without a password.",
    "passwordIsRequiredForVncTooltip": "Enter remote connection passwords manually.",
    "servicesDoNotMatchComposeFile": "No matching service found in the Docker Compose file. The remote connection cannot be established.",
    "serviceNotInComposeFile": "This service is not defined in Docker Compose file.",
    "passwordIsMissingForVnc": "Screen password is required to save this version."
  },
  "nodes": {
    "tree": {
      "title": "Node Tree",
      "dropForbidden": "Drop Forbidden",
      "deleteConfirm": "Delete location",
      "removeSubTitle": "All of the belonging nodes will be moved in the unassigned folder.",
      "addLocation": "Enter location folder name",
      "location": "Location",
      "locationNameMinLengthMsg": "Location name must be more than {msgLength} characters long",
      "locationNameMaxLengthMsg": "Location name must be less than {msgLength} characters long",
      "revertLastChange": "Revert Latest Drop",
      "multiselectInfoMsg": "Holding Shift key will enable multi-select",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "noMatchingNodes": "No matching nodes found",
      "cancelRequestMessage": {
        "nodeRequests": "The pending API request regarding previously selected node is canceled.",
        "dnaStatus": "The pending API request regarding DNA status of previously selected node is canceled.",
        "startSending": "The pending request for data emission start for the previously selected node is canceled."
      },
      "nodeMissing": "Node missing!",
      "overviewTab": "Overview",
      "logsTab": "Logs",
      "volumesTab": "Volumes",
      "remoteConnectionsTab": "Remote Connections",
      "labelsTab": "Labels",
      "settingsTab": "Settings"
    },
    "defaultTable": {
      "search": "Search",
      "rowsPerPage": "Rows per page:",
      "Delete": "Delete",
      "Disable": "Enable",
      "Enable": "Disable",
      "Clone": "Clone",
      "Export": "Export",
      "Deploy": "Deploy",
      "Copy": "Copy details",
      "DisabledCopy": "Copy details",
      "DisabledClone": "Clone",
      "DisabledExport": "Export",
      "DisabledDelete": "Delete",
      "DisabledDeploy": "Deploy",
      "CancelCreation": "Cancel creation",
      "DisabledCancelCreation": "Cancel creation",
      "Retry": "Retry",
      "DisabledRetry": "Retry",
      "Feedback": "Feedback",
      "DisabledFeedback": "Feedback",
      "MarkTaskAsFail": "Mark task as fail",
      "MarkTaskAsSuccess": "Mark task as success",
      "MarkTaskAsFinish": "Mark task as finished",
      "DisabledMarkTaskAsFail": "Mark task as fail",
      "DisabledMarkTaskAsSuccess": "Mark task as success",
      "DisabledMarkTaskAsFinish": "Mark task as finished",
      "Restore": "Restore"
    },
    "dna": {
      "dnaTab": "DNA",
      "nodeDnaTitle":"Node DNA",
      "workloadDnaTitle":"Workload DNA",
      "targetConfiguration": "Target Configuration",
      "lastDNAStateChange": "Last DNA state change",
      "status": "Status:",
      "currentConfiguration": "Current Configuration",
      "applyNewTargetConfiguration": "Apply new target configuration",
      "uploadTargetConfiguration": "Upload a new {dnaType} configuration file to apply to this node",
      "uploadTargetConfigurationTitle": "Drop file here or click to browse",
      "uploadTargetConfigurationMessage": "Accepted format: {acceptedFormat}",
      "targetConfigurationLabel": "Target configuration",
      "confirmationDialogTitle": "Warning",
      "confirmationDialogSubtitle": "Are you sure you want to re-apply the existing target configuration?",
      "dialogSubtitleEmptyConf": "Currently, there is no DNA configuration on the node. Applying Empty DNA configuration will erase all DNA settings, undeploying all workloads.",
      "confirmationDialogSubtitleEmptyConf": "Are you sure you want to proceed?",
      "wrongFileExtension": "Wrong file extension. Extension for uploaded file must be {textParams}",
      "nodeDna": "Node DNA: ",
      "workloadDna": "Workload DNA: ",
      "Applied": "Applied",
      "Initial": "Initial - not yet applied",
      "Modified": "Modified",
      "Canceling": "Canceling",
      "Undefined": "Undefined",
      "Reconfiguring": "Reconfiguring",
      "n/a": "n/a",
      "errorFeedbackTitle": "Error feedback",
      "errorMessage": "Message: ",
      "advancedOptions": "Advanced options",
      "continueInCaseOfRestart": "Continue in case of restart",
      "continueInCaseOfRestartTooltip": "DNA reconfiguration continues, following an offline period or reboot.",
      "restartDuringReconfig": "Restart workloads during reconfiguration",
      "restartDuringReconfigTooltip": "Restart the workloads on the node during DNA reconfiguration.",
      "removeDockerImages": "Remove Docker images",
      "removeDockerImagesTooltip": "Remove the Docker images of the Docker and Docker Compose workloads during DNA reconfiguration.",
      "signDnaFileText": "Sign the file",
      "unknownIntegrityStatus": "Workload hashes are missing and integrity cannot be confirmed. To ensure workload integrity, undeploy all workloads from the node and re-apply the DNA configuration.",
      "configurationSame": "The configuration is the same as the current one. No changes have been made."
    },
    "productionMode": {
      "enable": "Are you sure you want to enable production mode on the node?",
      "disable": "Are you sure you want to disable production mode on the node?",
      "enableTitle": "Enable production mode",
      "disableTitle": "Disable production mode",
      "productionModeOnMessage": "Production mode is successfully enabled",
      "productionModeOffMessage": "Production mode is successfully disabled",
      "productionModeEnabled": "Enable production mode",
      "productionModeDisabled": "Disable production mode",
      "productionModeReconfiguring": "Reconfiguring production mode"
    },
    "information": {
      "memoryUsage": "Memory usage",
      "dockerSpaceUsage": "Docker used space",
      "vmUsedSpace": "VM used space",
      "lifecycleEvents": "Lifecycle events",
      "chipButtonLabels": {
        "lifecycleEvents": "events",
        "nodeDetails": "details",
        "metadata": "metadata",
        "labels": "labels",
        "capabilities": "capabilities"
      },
      "showChips": "Show {count} {label}",
      "hideChips": "Hide {label}",
      "noChipsToShow": "No {label} to show",
      "created": "Created",
      "wanAddress": "Wan address",
      "capabilities": "Capabilities",
      "capability": "Capability",
      "labels": "Labels",
      "noLabels": "No Labels",
      "deleteNode": "Delete node",
      "internalLogLevel": "System log settings",
      "internalLogs": "View system logs",
      "viewSystemMetrics": "View system metrics",
      "system": "System",
      "docker": "Docker",
      "systemLogs": "System logs",
      "systemMetrics": "System metrics",
      "nodeManagement": "Node management",
      "systemLogFilter": {
        "allSyslogs": "All syslogs",
        "nerve": "Nerve",
        "audit": "Audit"
      },
      "setTime": "Time to keep this logging level active",
      "timeDescription": "The log levels will return to default value after this time.",
      "virtualization": "Virtualization",
      "codesys": "CODESYS",
      "workloadTypeFilter": {
        "vm": "VM",
        "docker": "Docker",
        "compose": "Docker Compose",
        "codesys": "CODESYS"
      },
      "workloadStatusFilter": {
        "started": "Started",
        "stopped": "Stopped",
        "suspended": "Paused",
        "error": "Error",
        "idle": "Idle",
        "other": "Other"
      },
      "systemLogsDescription": "The system logs are automatically sent to the Management System.",
      "systemLogsTitle": "Send system logs to the Management System.",
      "systemLogsFilterSupportedVersions": "The system logs are automatically sent to the Management System. This feature is supported on node versions 3.1.0 and above.",
      "viewSystemMetricsDescription": "Send system metrics to the Management System.",
      "dockerLogDescription": "Send Docker logs to the Management System.",
      "dockerMetricsDescription": "Send Docker metrics to the Management System.",
      "deleteConfirmationTitle": "Are you sure you want to delete the node {name}[{serialNumber}]?",
      "deleteConfirmationSubtitleSecondLine": "Removing the node from the Management System will result in removing all cloud data from this device, including user accounts.",
      "rebootNode": "Reboot node",
      "lastStart": "Last system start",
      "connections": "Connections",
      "connectionsTooltip": "Workload remote connection",
      "workloadStatusTooltip": "Workload status",
      "workloadTypeTooltip": "Workload type",
      "monitoringAndLoggingSettingsBtn": "Logs and metrics",
      "monitoringAndLoggingSettingsSuccessMessage": "Successfully applied logging and monitoring settings to the node.",
      "monitoringAndLoggingSettingsFailMessage": "Failed to apply logging and monitoring settings to the node.",
      "monitoringAndLoggingSettingsDialog": {
        "title": "Logging/Monitoring for node: ",
        "subTitle": "Displayed below is current logging and monitoring status for node: ",
        "dockerLoggingEnabled": "Docker workload logging enabled",
        "dockerLoggingDisabled": "Docker workload logging disabled",
        "dockerLogging": "Docker workload logs",
        "dockerWorkloadLogs": "View Docker workload logs",
        "dockerMonitoringEnabled": "Docker monitoring enabled",
        "dockerMonitoringDisabled": "Docker monitoring disabled",
        "dockerMonitoring": "Docker workload metrics",
        "dockerWorkloadMetrics": "View Docker workload metrics",
        "systemMonitoringEnabled": "System monitoring enabled",
        "systemMonitoringDisabled": "System monitoring disabled",
        "systemMonitoring": "System monitoring",
        "logging": "Logging ",
        "cancelBtn": "Cancel",
        "applyBtn": "Apply",
        "dashboard": "DASHBOARD",
        "closeBtn": "Close"
      },
      "systemMetricsOptions": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "dockerMonitoringOptions": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "dockerLoggingOptions": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "discardChangesDialogTitle": "Discard changes",
      "discardChangesDialogText": "You have made changes that haven't been saved yet. Are you sure to discard changes?",
      "type": "Type",
      "name": "Name",
      "versionName": "Version",
      "status": "Status",
      "cpu": "CPU",
      "ram": "RAM",
      "deployed": "Deployed",
      "lastChange": "Last change",
      "tableView": "Table view",
      "cardView": "Card view",
      "resetFilters": "Reset",
      "nodeDetails": "Node details",
      "secureBoot": "Secure boot",
      "timeZone": "Time zone",
      "metadata": "Metadata",
      "dnaNodeMetadata": "Node",
      "dnaWorkloadMetadata": "Workload",
      "deviceType": "Device type",
      "devices": {
        "statusText": "Status",
        "status": {
          "noCodesys": "",
          "idle": "Idle",
          "creating": "creating",
          "starting": "starting",
          "started": "started",
          "stopping": "stopping",
          "stopped": "stopped",
          "removing": "removing",
          "error": "error",
          "suspending": "pausing",
          "suspended": "paused",
          "resuming": "resuming",
          "restarting": "restarting",
          "removing_failed": "Removing failed",
          "partially_running": "Partially running"
        }
      },
      "removeUnusedDockerImages": "Remove unused Docker images",
      "removeUnusedDockerImagesConfirmationSubtitle": "Are you sure you want to remove all unused Docker images from node {name}[{serialNumber}]?",
      "version": "Version",
      "sn": "SN"
    },
    "list": {
      "addNode": "Add Node",
      "version": "Node version",
      "empty": "List of nodes is empty.",
      "name": "Name",
      "serialNumber": "Serial Number",
      "secureBoot": "Secure boot",
      "timeZone": "Time zone",
      "removeSubTitle": "Are you sure you want to delete the node {name}[{serialNumber}]?",
      "removeSubtitleSecondLine": "Removing the node from the Management System will result in removing all cloud data from this device, including user accounts.",
      "deleteConfirm": "Delete node",
      "deleteItem": "Node successfully deleted",
      "online": "online",
      "offline": "offline",
      "collapseAll": "Collapse all",
      "expandAll": "Expand all",
      "showAllColumns": "Show all columns",
      "showNameOnly": "Show name only",
      "indicators": "Indicators",
      "created": "Created",
      "loading": "Loading nodes...",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "search": "Search nodes...",
      "labelMenuTitle": "Group by:",
      "labelMenuTooltip": "Group by",
      "label": "Label",
      "property": "Property",
      "dnaNodeMetadata": "Node metadata",
      "dnaWorkloadMetadata": "Workload metadata",
      "labelSelectPlaceholder": "Search",
      "maxLabels": "Maximum {max} grouping levels",
      "deviceType":"Device type",
      "ipAddress": "IP address",
      "lastSystemStart": "Last system start",
      "lastSeen": "Last seen",
      "noResults": "No nodes match the current filter criteria.",
      "contextSelectItem": "Select item",
      "contextMoveHere": "Move here",
      "contextCancelSelection": "Cancel selection",
      "dropToRemoveFromFolder": "Drop here to remove from folder",
      "connection": "Connection",
      "nodeDna": "Node DNA",
      "workloadDna": "Workload DNA",
      "productionMode": "Production mode",
      "resetFilter": "Reset",
      "resetAllFilter": "Reset all",
      "resetFilterTooltip": "Clear all status filters.",
      "legacyInfoIconTooltip": "Nerve 3.1 or older node. The following statuses may not reflect the latest node state: node DNA status, workload DNA status, production mode."
    },
    "status": {
      "online": "Online",
      "offline": "Offline",
      "secureBootEnabled": "Enabled",
      "secureBootDisabled": "Disabled",
      "productionModeEnabled": "Production mode: Enabled",
      "productionModeDisabled": "Production mode: Disabled",
      "integrityCheckPassed": "Integrity check passed",
      "integrityCheckFailed": "Integrity check failed"
    },
    "addEditNode": {
      "invalidLabel": "Invalid input for label!",
      "wrongFormatForLabel": "Wrong format for label!",
      "duplicateKey": "Duplicate label key!",
      "labelInfo1": "Use this field to assign labels to node.",
      "labelInfo2": "Enter labels in format key:value (e.g. hardware:mfn100).",
      "labelInfo3": "Allowed values for key are: numbers, letters, - and _.",
      "labelInfo4": "Label is added on enter key.",
      "nodeSettings": "Node Settings",
      "add": "Add",
      "update": "Update",
      "name": "Name*",
      "secureId": "Secure ID*",
      "serialNumber": "Serial Number*",
      "required": "Required",
      "serialLength": "Serial number must have exactly 12 characters.",
      "securityLength": "To change Secure ID, enter the full new value. Secure ID must have exactly 16 or 32 characters.",
      "invalidName": "Node name must be of maximum length 40 and cannot contain special characters except _ and -",
      "invalidSecureId": "To change Secure ID, enter the full new value. Secure ID must consist of upper case letters and digits.",
      "invalidSerialNumber": "Serial number must consist of upper case letters and digits.",
      "addedNode": "Node successfully added",
      "updatedNode": "Node successfully updated",
      "timeZone": "Time zone",
      "hardware": "Hardware",
      "version": "Version"
    },
    "labels": {
      "addNewLabel": "Add new label",
      "key": "New label key",
      "value": "New label value",
      "emptyTable": "No labels assigned to this node.",
      "assignSuccess": "Label successfully assigned to node.",
      "assignFail": "Failed to assign label to node.",
      "unassignAction": "Unassign label",
      "editLabelAction": "Edit label",
      "cancelAction": "Cancel",
      "confirmAction": "Confirm",
      "unassignSuccess": "Label successfully unassigned from node.",
      "unassignFail": "Failed to unassign label from node.",
      "showingCount": "Showing {shown} of {total} labels",
      "editSuccess": "Label successfully updated.",
      "importLabels": "Import labels",
      "exportLabels": "Export labels",
      "unassignAll": "Unassign all",
      "importSuccess": "Labels successfully imported.",
      "importFail": "Failed to import labels.",
      "exportFail": "Failed to export labels.",
      "unassignAllSuccess": "All labels successfully unassigned.",
      "unassignAllFail": "Failed to unassign all labels."
    },
    "deployedWorkloadControl": {
      "updateBtn": "Replace version",
      "snapshotBtn": "Snapshot",
      "vmBackupsBtn": "Backup",
      "undeployedSuccessfully": "Workload successfully undeployed.",
      "network": "Network info",
      "undeployBtn": "Undeploy",
      "messageTitle": "Message",
      "statusMessage": "{name} {status}.",
      "statusMessageTitle": "{name}",
      "statusLbl": "Status",
      "progress": {
        "cpu": "CPU",
        "ram": "RAM"
      },
      "timeOfChange": "Last status change",
      "confirmTitle": "Are you sure you want to undeploy workload?",
      "confirmMessage": "Do not remove images from the node",
      "undeployWorkload": "Undeploy workload",
      "applyWorkloadConfigurationBtn": "Apply configuration",
      "workloadConfigurationMessageTitle": "Workload configuration",
      "workloadConfigurationComposeMessageTitle": "Service configuration",
      "workloadConfigurationMessageContainerPath": "Container path:",
      "workloadConfigurationMessageVolumeName": "Volume name:",
      "workloadConfigurationMessageStatus": "Status: ",
      "workloadConfigurationMessageInitiatedBy": "Initiated by:",
      "workloadConfigurationMessageContent": "Message:",
      "workloadConfigurationMessageNoConfigurationApplied": "No configuration applied to this workload yet.",
      "workloadConfigurationStatusSUCCESS": "Success",
      "workloadConfigurationStatusFAILED": "Failed",
      "workloadConfigurationStatusNoStatus": "",
      "workloadConfigurationStatusIN_PROGRESS": "In progress",
      "fileNamePlaceholder": "filename.zip",
      "applyWorkloadConfigurationDialog": {
        "title": "Apply configuration for {workloadName}",
        "successMessage": "Apply configuration request sent.",
        "applyButton": "Apply",
        "cancelButton": "Cancel",
        "uploadFileTooltip": "Upload file",
        "removeFileTooltip": "Remove file"
      },
      "downloadCodesysAppArchive": "Download CODESYS App Archive",
      "networksPropertiesDialog": {
        "title": "Network info",
        "emptyState": "There is no network to display",
        "interfaceName": "Interface name",
        "source": "Source",
        "macAddress": "MAC Address",
        "ipAddress": "IP Address",
        "receivedBytes": "Received KB",
        "transmittedBytes": "Transmitted KB",
        "transmittedBytesTooltip": "Network data traffic since last Virtual Machine start",
        "closeBtn": "Close",
        "errorMessage": "Failed to fetch network properties",
        "vif131": "vif13.1-emu",
        "vif132": "vif13.2-emu"
      },
      "overview": "Overview",
      "details": "Details",
      "backup": "Backup",
      "snapshot": "Snapshot",
      "node": "Node",
      "connections": "Connections",
      "name": "name",
      "type": "type",
      "port": "port",
      "rcColumnServiceName": "service",
      "approval": "approval",
      "environmentVariables": {
        "title": "Environment Variables",
        "variable": "Variable",
        "value": "value",
        "noEnvironmentVariables": "There are no environment variables to display.",
        "environmentVariablesMessage": "The data in the table is retrieved using docker inspect command"
      },
      "portMappings": {
        "title": "Port Mapping",
        "noPortMappings": "There are no exposed ports.",
        "protocol": "Protocol",
        "hostPort": "Host Port",
        "containerPort": "Container Port"
      },
      "networks": {
        "title": "Networks",
        "noNetworks": "There are no networks to display.",
        "name": "Name"
      },
      "volumes": {
        "title": "Volumes",
        "noVolumes": "There are no volumes defined for this service.",
        "name": "Name",
        "path": "Path"
      },
      "downloadInspectCommandResults": "Download the output of docker inspect command",
      "releaseName": "For older node versions, the release name is shown due to compatibility reasons.",
      "networkPropertiesMessages": "Network properties cannot be displayed when the VM is stopped.",
      "Stop": "Stop",
      "Pause": "Pause",
      "Play": "Start",
      "Restart": "Restart",
      "Undeploy": "Undeploy",
      "Start": "Start",
      "dockerComposeInfoMessage": "Services are not ready yet."
    },
    "volumes": {
      "title": "Volumes",
      "volumeName": "Volume name",
      "size": "Size",
      "workload": "Workload versions",
      "noVolumesOnNode": "There are currently no volumes in use by any Docker or Docker Compose workloads on this device.",
      "noSearchResults": "No volumes match the current search criteria.",
      "deleteVolume": "Delete volume",
      "subtitle": "Are you sure you want to remove this volume {name}?",
      "successfullyDeleted": "Volume successfully deleted.",
      "download": "Download link",
      "ms": "Management System",
      "creationInitiatedAt": "Export initiated at: {date}",
      "remainingTime": "Archive available for: {time}",
      "importCompleted": "Import successfully completed.",
      "exportCompleted": "Exported file is ready for download.",
      "exportCancelled": "Volume export has been cancelled.",
      "importCancelled": "Volume import has been cancelled.",
      "nodeOffline": "Node is offline. Volumes cannot be displayed.",
      "exportFailed": "Volume export failed during upload to the Management System. For more details check logs."
    },
    "reboot": {
      "confirmMessage": "Are you sure you want to reboot the node {name} [{serialNumber}]?",
      "error": "Node {name}[{serialNumber}] reboot failed.",
      "rebootStarted": "Reboot of a node {name}[{serialNumber}] has been initiated.",
      "notAllowed": "Reboot operation is not allowed on the node {name}[{serialNumber}]."
    },
    "activityLogs": {
      "activityLogs": "Activity Log",
      "logs": "Logs",
      "download": "Download",
      "refresh": "Refresh",
      "viewActivityLogsDescription": "Audit logs in OpenSearch",
      "downloadMessage": "Download the activity log for the selected the node",
      "nodeActivityTitle": "Node Activity",
      "nodeTitle": "Node",
      "auditLogs": "Audit logs in OpenSearch",
      "accessAuditLogs": "Access the audit logs of the selected node",
      "nodeAuditLogsTitle": "Node audit logs",
      "msAuditLogs": "Triggered from the Management System",
      "msAuditLogsMessage": "Audit logs triggered directly by the Management System.",
      "nodeAuditLogs": "Triggered from the Node",
      "nodeAuditLogsMessage": "Audit events originated from the Local UI or Node API.",
      "dockerAuditLogsBtn": "VIEW AUDIT LOGS",
      "dockerAuditLogsMessage": "Access the audit logs of this workload to track and monitor critical and security related events.",
      "workloadActivity": "Workload activity"
    }
  },
  "workloadTable": {
    "started": "Started",
    "stopped": "Stopped",
    "suspended": "Paused",
    "error": "Error",
    "idle": "Idle",
    "removing_failed": "Removing failed",
    "n/a": "N/A",
    "restarting": "Restarting",
    "creating": "Creating",
    "removing": "Removing",
    "suspending": "Pausing",
    "starting": "Starting",
    "resuming": "Resuming",
    "stopping": "Stopping",
    "partially_running": "Partially running",
    "created": "Created",
    "paused": "Paused",
    "dead": "Dead",
    "resetFilter": "Reset",
    "containerStatusFilter": "Container status"
  },
  "addUpdateNode": {
    "labels": "Insert label"
  },
  "nodeUpdate": {
    "successfullyUpdated": "Created node update operation has been pushed to queue and waiting to be executed.",
    "compatibleNodesTitle": "Compatible nodes",
    "updateButton": "Update",
    "selectAll": "Select all",
    "name": "Name",
    "releaseDate": "Release date",
    "serialNumber": "Serial Number",
    "currentVersion": "Current version",
    "compatibleNodesList": {
      "emptyText": "There are no compatible nodes."
    },
    "nodeUpdateList": {
      "emptyText": "There is no available node updates at the moment."
    },
    "manualPatchRequiredTitle": "Manual patch required",
    "manualPatchRequiredMessage": "This node version requires a manually applied patch before update. Please make sure it was executed. If you have any doubts please contact the TTTECH Support."
  },
  "nodeConfiguration": {
    "removeUnusedDockerImagesSuccessMessage": "Unused Docker images successfully removed from node {textParams}."
  },
  "nodeUpdateDetails": {
    "title": "Details of node update operation {operation_name}",
    "titleOfNodeOperation": "Details of node update operation",
    "success": "Success",
    "inProgress": "In progress",
    "failed": "Failed",
    "noInformationYet": "No information yet, please check after task is finished",
    "operationTaskTitle": "Operation task list",
    "feedback": "FEEDBACK",
    "errorFeedbackTitle": "Error feedback for device {device}",
    "markAsFinish": "MARK AS FINISHED",
    "nodeUpdateDetailsTable": {
      "device": "Device",
      "status": "Status",
      "progress": "Status",
      "started": "Started",
      "finished": "Finished",
      "emptyList": "No update task was found"
    }
  },
  "ldap": {
    "ldapAuthentication": "LDAP Authentication(off/on)",
    "ldapAuthenticationTitle": "LDAP authentication",
    "delete": "DELETE",
    "emptyList": "List of Ldaps is empty.",
    "updateMessage": "The changes you made have not been saved. Do you want to save?",
    "updateLdapMessage": "Ldap configuration successfully updated",
    "createLdapMessage": "Ldap configuration successfully created",
    "loadDefaultLdapMessage": "Default LDAP successfully loaded",
    "noControlCharacter": "Control characters are not allowed.",
    "invalid_port_range": "Invalid",
    "syncLdapMessage": "Successful synchronisation",
    "LdapActivated": "LDAP authentication is activated.",
    "LdapDeactivated": "LDAP authentication is deactivated.",
    "activeAuthDialog": "This action will activate current LDAP configuration resulting in allowing only LDAP users to be able to login.",
    "deactivateAuthDialog": "This action will deactivate current LDAP authentication resulting in allowing only local users to be able to login.",
    "ldapConnection": {
      "title": "Connection:",
      "name": "Name",
      "url": "URL",
      "port": "Port",
      "bindDN": "Bind DN",
      "password": "Password",
      "secureConnectionOption": "Secure connection option TLS/SSL",
      "required": "This field is required",
      "portRequired": "Required",
      "testConnection": "Test connection",
      "passwordMinLengthMsg": "Password must be more than {msgLength} characters long",
      "passwordMaxLengthMsg": "Password must be less than {msgLength} characters long",
      "invalidFileName": "Invalid file name.",
      "Loading": "Loading default LDAP configuration file"
    },
    "ldapSynchronization": {
      "title": "Groups and Users synchronization parameters:",
      "searchBase": "Search base",
      "filter": "Filter",
      "group": "Group",
      "user": "User",
      "groups": "Groups",
      "users": "Users",
      "required": "This field is required",
      "timeRequired": "Required",
      "groupName": "Group name",
      "adminGroup": "Admin group",
      "defaultRole": "Default role",
      "firstName": "First name",
      "lastName": "Last name",
      "username": "Username",
      "sync": "Sync now",
      "email": "Email",
      "syncTitle": "Synchronization:",
      "recurringSync": "Recurring Sync",
      "schedule": "Schedule",
      "startingTime": "hh:mm",
      "intervalTime": "hh",
      "testGroupsSync": "Test Groups Sync",
      "testUsersSync": "Test Users Sync",
      "execute": "Execute",
      "close": "Close",
      "testGroupsQuery": "Test query for groups",
      "testUsersQuery": "Test query for users",
      "loading": "Loading... Please wait",
      "userGroupRelationship": "User and group relationship",
      "membershipAttribute": "Member",
      "targetAttribute": "Target",
      "userGroupRelationshipRadio": "User -> Group relationship",
      "groupUserRelationshipRadio": "Group -> User relationship",
      "syncInformation": "Server time zone will be used for the synchronization starting time.",
      "name": "Name",
      "description": "Description",
      "groupEmptyState": "No group was found",
      "userEmptyState": "No user was found",
      "timePickerTitle":"Select time"
    }
  },
  "workloadDetail": {
    "title": "Update Virtual machine Workload",
    "list": {
      "version": "Versions",
      "createVersion": "Create version",
      "emptyList": "List of versions is empty."
    },
    "description": "Description",
    "name": "Name *",
    "headerName": "Name",
    "required": "Required",
    "updateDocker": "Docker workload",
    "updateVm": "Virtual machine workload",
    "updateCodesys": "CODESYS workload",
    "updateCompose": "Docker Compose workload",
    "edit": "EDIT",
    "clone": "CLONE",
    "export": "EXPORT",
    "cancelCreation": "CANCEL CREATION",
    "workloadCreationCanceled": "Creation cancelled",
    "downloadError": "Download error",
    "notReleased": "Not released",
    "released": "Released",
    "dialog": {
      "title": "Delete version",
      "subTitle": "Are you sure you want to delete this version?",
      "successfullyDeleted": "Version successfully deleted"
    },
    "successfullyUpdate": "Workload successfully updated",
    "successfullyCreate": "Workload successfully created",
    "back": "Back",
    "wlNameContainControlCharacter": "Invalid name! Name cannot contain control character.",
    "wlNameContainOnlySpaces": "Invalid name! Name cannot contain only whitespaces."
  },
  "workloadVersion": {
    "add": "Add",
    "update": "Update",
    "versionName": "Version name*",
    "versionNameCompose": "Name*",
    "required": "Required",
    "workloadVersionNamePattern": "Version name field must be of maximum length 40 and cannot contain special characters.",
    "configurationStorage": "Configuration storage",
    "emptyState": "No configuration storage",
    "selector": "Selector:",
    "versionSpecificInfo": "Version Specific Info",
    "versionSpecificInfoCompose": "Version Specific Info",
    "dockerImage": "Docker Image",
    "dockerNetworks": "DOCKER NETWORKS",
    "networkInterfaces": "NETWORK INTERFACES",
    "portMapping": "PORT MAPPING",
    "environmentVariable": "ENVIRONMENT VARIABLE",
    "dockerVolumes": "DOCKER VOLUMES",
    "resourcesTitle": "RESOURCES",
    "diskTitle": "DATA DISK",
    "disks": "Data disk",
    "requiredDisks": "Data disk*",
    "dockerSpecificInfo": "DOCKER SPECIFIC INFO",
    "virtualSpecificInfo": "VIRTUAL MACHINE SPECIFIC INFO",
    "containerName": "Container name*",
    "networkName": "Network name*",
    "containerNamePattern": "Container name must contain only numbers, letters, _ and -. Container name must be unique and start with number and letters with at least 2 characters.",
    "containerNetworkPattern": "Container network must contain only numbers, letters, _ and -. Container network must be unique and start with number and letters with at least 2 characters.",
    "containerNetworkDuplicate": "Duplicate docker network",
    "dockerNetwork": "Docker network",
    "restartPolicyNo": "no",
    "restartPolicyOnFailure": "on-failure",
    "restartPolicyAlways": "always",
    "restartPolicyUnlessStopped": "unless-stopped",
    "restartPolicy": "Select restart policy",
    "cpuResource": "CPU resource in percentage",
    "limitMemory": "Limit memory must have a value greater than 0.",
    "cpuResourceInfoMessage1": "Maximum allowed CPU usage in percent,",
    "cpuResourceInfoMessage2": "e.g. 50% = 1/2 CPU, 100% = 1 CPU, 300% = 3 CPUs",
    "basic": "Basic",
    "requiredBasic": "Basic*",
    "registriesAndServices": "Registries and Services",
    "serviceConfiguration": "Service configuration",
    "serviceConfiguration*": "Service configuration*",
    "requiredRegistriesAndServices": "Registries and Services*",
    "networking": "Networking",
    "requiredNetworking": "Networking*",
    "environmentVariables": "Environment Variables",
    "requiredEnvironmentVariables": "Environment Variables*",
    "versionPciPassthrough": "PCI Passthrough",
    "requiredVersionPciPassthrough": "PCI Passthrough*",
    "volumes": "Volumes",
    "requiredVolumes": "Volumes*",
    "resources": "Resources",
    "requiredResources": "Resources*",
    "remoteConnections": "Remote Connections",
    "numberOfVirtualCpuRange": "Number of CPUs must be a positive integer.",
    "numberOfVirtualCpu": "Number of virtual CPUs*",
    "advancedDockerOptions": "ADVANCED DOCKER OPTIONS",
    "advancedVmOptions": "ADVANCED VIRTUAL MACHINE OPTIONS",
    "restartOnConfUpd": "Restart on configuration update",
    "markFirstVolume": "Mark first volume as a configuration storage",
    "newEnvironmentVariable": "New environment variable",
    "envVariable": "Env. variable",
    "variableValue": "Variable value",
    "variableValuePattern": "Control characters are not allowed for variable value.",
    "envVariablePattern": "Variable name must contain only numbers, letters and _. A variable name must not start with a digit and must be unique.",
    "successfullyUpdate": "Workload successfully updated",
    "successfullyCreated": "Workload successfully created",
    "snapshotEnabledVmTooltip": "filename.qcow2, filename.zip or filename.qcow2.gz",
    "snapshotDisabledVmTooltip": "filename.img, filename.raw, filename.qcow2, filename.zip, filename.img.gz, filename.raw.gz or filename.qcow2.gz",
    "vmTitle": "VIRTUAL MACHINE FILES TO UPLOAD",
    "vmImageLabel": "Virtual machine image*",
    "vmXmlLabel": "Virtual machine xml*",
    "codesysTitle": "CODESYS FILES TO UPLOAD",
    "dockerTitle": "Docker image",
    "imagePlaceholder": "VM image file",
    "xmlPlaceholder": "filename.xml",
    "dockerPlaceholder": "filename.tar",
    "dockerComposePlaceholder": "Pull from registry",
    "dockerLabel": "Docker container image",
    "uploadBtnTooltip": "Upload file",
    "codesysPlaceholder": "filename.zip",
    "codesysLabel": "CODESYS project file*",
    "imagePathLabel": "Image path*",
    "DockerFromRegistryOption": "From registry",
    "DockerUploadOption": "Upload",
    "usernameLabel": "Username",
    "passwordLabel": "Password",
    "newPCIPassthrough": "PCI passthrough",
    "pciPassthrough": "PCI passthrough*",
    "dockerImagePathPattern": "The Docker image path is required and must follow the correct format. The maximum allowed length for the image name is 255 characters and 128 characters for the tag.",
    "dockerImageNerveInternalRegistryPathPattern": "The Docker image path is required and must follow the correct format. The maximum allowed length for the image name is 255 characters and 128 characters for the tag. When using the internal Nerve registry, the 'registry/' prefix is added automatically and should not be included manually.",
    "dockerUsernamePattern": "Username does not contain colon ':' or any control character.",
    "dockerPasswordPattern": "Control characters are not allowed for password.",
    "pciPassthroughPatternValidation": "PCI passthrough device should be in expected format: 'pci_xxxx_xx_xx_x', including only hexadecimal numbers.",
    "pciPassthroughDuplicateValidation": "Duplicate PCI",
    "dockerPasswordLength": "Password must contain at least 1 character",
    "dockerUsernameLength": "Password must contain at least 1 character",
    "ports": {
      "protocol": "Protocol",
      "hostPort": "Host Port",
      "containerPort": "Container Port",
      "guestPort": "Guest Port",
      "newPort": "New port",
      "portPattern": "Must have a value between 0 and 65536. Host port and Container port must be unique.",
      "duplicatePort": "Duplicate ports",
      "tcp": "TCP",
      "udp": "UDP"
    },
    "dataDisk": {
      "MB": "MB",
      "KB": "KB",
      "GB": "GB",
      "TB": "TB",
      "title": "DATA DISK",
      "newDataDisk": "New data disk",
      "dataDiskName": "Data disk name*",
      "diskSize": "Disk size*",
      "duplicateDataDisk": "Duplicate data disk name",
      "patternDiskName": "Data disk name must contain numbers, letters and _. Data disk name must be unique.",
      "patternDiskSize": "Memory input must contain numbers without any characters. Maximum number of decimal places is 3"
    },
    "enableSnapshot": "Enable snapshot",
    "snapshotNote": "Snapshot option requires a QCOW2 VM image (uncompressed or zipped)",
    "snapshotWarning": "Snapshot option is not applicable with the current VM image type",
    "snapshotInfoMessage1": "The disk space required for the Snapshot depends on several factors.",
    "snapshotInfoMessage2": "To define the snapshot disk space consider the VM disk size,",
    "snapshotInfoMessage3": "the amount of RAM assigned to the VM and 2%-3% of overhead.",
    "additionalDiskSpace": "Additional disk space",
    "volume": {
      "newVolume": "New volume",
      "volumePattern": "Docker volume is in invalid format. Please check that both, volume name and path contain only numbers, letters and characters '-', '.' and '_'.",
      "volumeNameLabel": "Volume name",
      "volumePathLabel": "/path/in/container",
      "duplicateVolumeName": "Duplicate volume name"
    },
    "progressBarDialog": {
      "savingWorkload": "Saving Workload",
      "uploadingWorkload": "Uploading Workload"
    },
    "interfacePlaceholder": "Interface",
    "interface": "New interface*",
    "newNetworkInterface": "New interface",
    "interfaceType": {
      "bridged": "Bridged",
      "nat": "NAT"
    },
    "duplicateInterface": "Duplicate name",
    "networkInterfacePattern": "Interface must contain only numbers, letters _ and -. Interface name must be unique.",
    "markAsReleased": "Mark as released",
    "memoryInputPatternMessage": "Memory input must contain numbers without any characters. Maximum number of decimal places is 3.",
    "titleResources": "RESOURCES",
    "portsTitle": "Ports",
    "markAsReleasedMessageTitle": "Current version marked as released",
    "markAsReleasedMessageText": "Please be aware that current version is marked as released and that won't be possible to edit it anymore if you confirm save.",
    "snapshotEnabledAndZipArchiveTitle": "VM snapshot option enabled",
    "snapshotEnabledAndZipArchiveText": "Snapshot option requires a QCOW2 image. Make sure the compressed VM image is QCOW2 image. Do you want to proceed?",
    "confirmSaveSnapshotAndZipAndReleasedTitle": "Version marked as released and VM snapshot option enabled",
    "confirmSaveSnapshotAndZipAndReleasedText": "Be aware that current version is marked as released and that won't be possible to edit it anymore if you confirm save. Also make sure the compressed VM image is QCOW2 image, as snapshot option requires a QCOW2 image",
    "unknownSelector": "Only existing labels may be used to define selectors.",
    "composePlaceholder": "filename.json",
    "composeLabel": "Docker Compose file",
    "validComposeFile": "Docker Compose file is valid. Additional checks will be performed at deployment time!",
    "invalidComposeFile": "Docker Compose file is not valid",
    "labelInfo1": "Use this field to assign labels to workload version.",
    "uniqueInfo": "Workload name, version and hash copied to clipboard.",
    "uniqueInfoError": "Something went wrong with copying action.",
    "dockerComposeInfoMessage": "Upload a Docker Compose file first then move to the other tabs for additional configurations",
    "titleRegistry": "REGISTRIES",
    "titleServices": "SERVICES",
    "services": {
      "name": "Name",
      "imageName": "Image name",
      "imageFile": "Image file (Optional)",
      "configurationStorage": "Configuration storage",
      "restartOnConfUpdate": "Restart on conf. update",
      "empty": "List of services is empty",
      "fileOptionsRegistry": "From registry",
      "fileOptionsUpload": "Image upload",
      "unselectUpload": "Pull image from registry",
      "fileInfoMessage": "Uploads take precedence over registry images.",
      "service": "Service",
      "image": "Image",
      "status": "Status",
      "lastStateChange": "Last state change"
    },
    "versionHasChanged": "Warning: The definition of the currently deployed workload does not align with the version stored in Management System.",
    "versionHasChangedSinceRc": "Warning: The definition of the workload has been updated since the remote connection was established.",
    "passwordIsRequiredForRegistryCompose": "You need to set the registry passwords explicitly.",
    "passwordIsRequiredForRegistry": "You need to set the password for the registry manually."
  },
  "labels": {
    "list": {
      "addLabel": "Add Label",
      "empty": "List of labels is empty.",
      "loading": "Loading labels...",
      "key": "Key",
      "value": "Value",
      "deleteConfirm": "Delete label",
      "removeSubTitle": "Are you sure you want to delete this label? This will delete label from Nodes and Workload versions also.",
      "deletedItem": "Label successfully deleted",
      "showAllLabels": "Show all {numberOfLabels} labels",
      "nodeLabels": "Node Labels",
      "close": "Close"
    },
    "details": {
      "add": "Add",
      "update": "Update",
      "save": "Save",
      "cancel": "Cancel",
      "labelKey": "Label key",
      "labelValue": "Label value",
      "required": "This field is required",
      "labelKeyPattern": "Only numbers, letters, _ and - are allowed.",
      "labelValuePattern": "Whitespace characters are not allowed.",
      "maxLength": "This field can not be longer than {fieldLength}.",
      "successUpdate": "Label successfully updated",
      "successCreate": "Label successfully created"
    },
    "merge": {
      "keysHeader": "Keys",
      "caseHeader": "Case",
      "numOfOccurrences": "Number of occurrences",
      "cancelBtn": "Cancel",
      "mergeBtn": "Merge",
      "mergeLabels": "Merge labels",
      "saveBtn": "Save",
      "emptyTable": "List of labels is empty.",
      "fixCase": "Fix case",
      "fixCaseLabel": "Type new name for key",
      "successfullyMerged": "Successfully merged",
      "title": "Merge labels"
    }
  },
  "workloads": {
    "list": {
      "emptyList": "List of workloads is empty.",
      "deleteWorkload": "Delete workload",
      "successfullyDeletedWorkload": "Workload successfully deleted",
      "removeSubTitle": "Are you sure you want to delete this workload?",
      "disable": "DISABLE",
      "enable": "ENABLE",
      "disableConfirm": "Change workload status",
      "disableSubTitle": "Are you sure you want to enable/disable workload?",
      "workloadType": "Workload type",
      "showDisabled": "Show disabled",
      "headerName": "Name",
      "headerType": "Type",
      "headerCreated": "Created",
      "all": "All",
      "vm": "VM",
      "docker": "Docker",
      "codesys": "CODESYS",
      "compose": "Docker Compose",
      "addDockerCompose": "Add new Docker Compose workload",
      "addVm": "Add new VM workload",
      "addDocker": "Add new Docker workload",
      "addCodesys": "Add new CODESYS workload"
    }
  },
  "deployForm": {
    "workloadStep1": {
      "title": "Workload deployment - select workload",
      "typeTitle": "Workload type",
      "typeText": "Select workload type to show workload.",
      "dockerBtn": "Docker",
      "vmBtn": "Virtual Machine",
      "codesysBtn": "CODESYS",
      "docker-composeBtn": "Docker Compose",
      "workloadTitle": "Workload",
      "workloadText": "Select workload to show workload version.",
      "workloadVersion": "Workload version",
      "selectWorkload": "Select workload version to deploy",
      "createdColumn": "Created",
      "workloadList": {
        "name": "Workload name",
        "description": "Description",
        "emptyText": "List of workloads is empty."
      },
      "versionList": {
        "name": "Name",
        "emptyText": "List of versions is empty."
      }
    },
    "workloadStep2": {
      "title": "Workload deployment - select target nodes",
      "nodeList": {
        "emptyText": "List of nodes is empty.",
        "name": "Name",
        "type": "Type",
        "serialNumber": "Serial number",
        "nodeVersion": "Node version"
      },
      "nodes": "Nodes:",
      "selectedNodes": "Selected nodes:",
      "selectAll": "Select all"
    },
    "workloadStep3": {
      "title": "Workload deployment - check and execute",
      "deployName": "Deploy name*",
      "workloadType": "Workload type:",
      "workloadName": "Workload name:",
      "workloadVersion": "Workload version:",
      "deployExecute": "Deploy will be executed on:",
      "node": "Node",
      "nodes": "Nodes",
      "required": "Required.",
      "workloadUpdateWarningMessage": "Workload update will be performed if this workload was previously deployed on the node.",
      "nodeNameMax": "Deploy name can contain up to 40 character",
      "nodeNameMin": "Deploy name must contain at least 1 character",
      "noControlCharacters": "Control characters are not allowed."
    },
    "executeStep": {
      "deployBtn": "Deploy"
    },
    "backBtn": "Back",
    "nextBtn": "Next",
    "duplicateNameOfDeploy": "The deployment name '{oldDeployName}' already exists, it has been renamed to '{newDeployName}'",
    "successDeploy": "Created deployment has been pushed to queue and waiting to be executed.",
    "confirmDialogTitle": "This workload cannot be deployed to the node(s)",
    "confirmDialogText": "The reported node(s) can only manage single-service Docker Compose workloads. Please remove incompatible node(s) from the target nodes and try again."
  },
  "deployLog": {
    "list": {
      "emptyList": "List of deploy operation is empty.",
      "headerName": "Deploy name",
      "headerAction": "Deployment type",
      "headerProgress": "Status",
      "headerStarted": "Started",
      "headerFinished": "Finished",
      "deleteConfirm": "Delete deploy operation",
      "successfullyDeleted": "Deploy operation has been successfully deleted.",
      "removeSubTitle": "Are you sure you want to delete this deploy operation? If this deploy operation is deleted all of its tasks will be deleted too.",
      "all": "All",
      "deploy": "Deploy",
      "vm": "VM",
      "docker": "Docker",
      "codesys": "CODESYS",
      "canceled": "Canceled",
      "docker-compose": "Docker Compose",
      "workloadName": "Workload name",
      "versionName": "Version name"
    }
  },
  "updateDeployedWorkload": {
    "name": "Name",
    "update": "Update",
    "availableVersions": "Available versions",
    "cancel": "Cancel",
    "successUpdate": "Updated deployment has been pushed to queue and waiting to be executed.",
    "wlUpdateInformationMessage": "There are no compatible versions for selected workload.",
    "cleanStart": "Re-deploy workload version by executing Docker Compose down to ensure clean start"
  },
  "roles": {
    "list": {
      "addRole": "Add Role",
      "removeSubTitle": "Are you sure you want to delete this role?",
      "deleteConfirm": "Delete role",
      "infoTitle": "Delete information",
      "infoSubTitle": "Delete method is not allowed! One or more users use this role.",
      "loading": "Loading roles..."
    }
  },
  "access": {
    "roles": {
      "list": {
        "name": "Name",
        "type": "Type",
        "numberOfAssignedUsers": "Number of assigned users",
        "description": "Description",
        "userType": "User type",
        "deletedItem": "Role successfully deleted",
        "emptyState": "No role was found",
        "filter": {
          "all": "All",
          "local": "Local",
          "ldap": "Ldap"
        }
      },
      "roleDetails": {
        "name": "Name*",
        "description": "Description*",
        "cancelBtn": "Cancel",
        "saveBtn": "Save",
        "updateBtn": "Update",
        "uiPermissions": "UI PERMISSIONS",
        "apiPermissions": "API PERMISSIONS",
        "roleNameRequired": "Role name is required field",
        "roleNameMinLengthMsg": "Role name must contain at least 1 character",
        "roleNameMaxLengthMsg": "Role name can contain up to 64 character",
        "roleDescriptionRequired": "Role description is required field",
        "roleDescriptionMinLengthMsg": "Role description must contain at least 1 character",
        "roleDescriptionMaxLengthMsg": "Role description can contain up to 64 character",
        "uiPermissionsTab": "UI PERMISSIONS",
        "apiPermissionsTab": "API PERMISSIONS",
        "searchInputLabel": "Search",
        "emptyRoleMsg": "At least one permission must be checked!",
        "categoriesTitle": "All Categories",
        "uiPermissionHeader": "PERMISSION",
        "uiDescriptionHeader": "DESCRIPTION",
        "uiNameHeader": "NAME",
        "apiNameHeader": "NAME",
        "apiCategoryHeader": "CATEGORY",
        "roleNameSpecialCharacters": "Role name must not include special characters like: ' _ ' , ' - ' , ' ? ' , ' + '  , ...",
        "updatedSuccessfully": "Role successfully updated",
        "createdSuccessfully": "Role successfully created",
        "apiPermissionsDialogTitle": "Confirm action",
        "apiPermissionsDialogMsg": "Deselecting API permissions might make this role unusable by the system.",
        "apiPermissionsDialogCheckbox": "Do not show this message again",
        "apiPermissionsConfirmAction": "Confirm",
        "apiPermissionsCancelAction": "Cancel",
        "noUiPermissionsToShow": "No UI PERMISSIONS to show",
        "noApiPermissionsToShow": "No API PERMISSIONS to show",
        "loadingPermissions": "Loading permissions..."
      }
    }
  },
  "usageReports": {
    "list": {
      "title": "Usage reports",
      "tttechNotifyText": "Automatically transport monthly report to ",
      "emptyList": "List of usage reports is empty.",
      "currentReportLabel": "Download report for the current month",
      "downloadMessage": "Click to download usage report",
      "downloadPublicKeyLabel": "Download the public key to be used by TTTech to verify signed reports"
    }
  },
  "availableUpdates": {
    "list": {
      "title": "Available updates",
      "versionNumber": "Version number",
      "releaseDate": "Release date",
      "emptyState": "Currently no available versions for update",
      "updateVersion": "Version {version}",
      "message": "Please contact Nerve support team to install available updates (mail: support{'@'}tttech-industrial.com).",
      "listOfNotCompatibleNodes": "Some nodes are not compatible with this version of the Management system"
    }
  },
  "about": {
    "version": "Version",
    "buildDate": "Build date",
    "gitCommit": "Git commit"
  },
  "auditLogs": {
    "list": {
      "title": "Logs"
    },
    "information": {
      "managementSystemLogsDescription": "These logs offer valuable information for troubleshooting, maintenance and system optimization",
      "auditLogsDescription": "Access the audit logs to track and monitor critical and security related events",
      "auditLogs": "View audit logs",
      "managementSystemLogs": "View management system logs"
    }
  },
  "notifications": {
    "list": {
      "addNotification": "Add Notification",
      "message": "Message",
      "headerText": "Header text",
      "empty": "List of Notifications is empty.",
      "removeSubTitle": "Are you sure you want to delete this notification?",
      "deleteConfirm": "Delete notification",
      "removeNotification": "Notification successfully deleted",
      "active": "Active",
      "yes": "Yes",
      "no": "No"
    },
    "addEdit": {
      "add": "Add",
      "update": "Update",
      "headerText": "Header text",
      "textMessage": "Text message",
      "active": "Active",
      "showBeforeLogin": "Display notification message before login",
      "backgroundImage": "Dialog background image:",
      "loadingImage": "Loading image",
      "uploadDragAndDropImage": "Click or drag and drop image here",
      "wrongImgExtensionMsg": "Only .jpeg, .jpg and .png file types are allowed.",
      "maxImgSizeExceededMsg": "Maximum file size of 5 MB is exceeded!",
      "required": "This field is required",
      "noControlCharacter": "Control characters are not allowed.",
      "nameMaxLengthMsg": "Name can contain up to {msgLength} characters",
      "headerTextLengthMsg": "Header text can contain up to {msgLength} characters",
      "textMessageLengthMsg": "Text message can contain up to {msgLength} characters",
      "headerTextOnlySpaces": "Invalid header text! A header cannot contain only whitespaces.",
      "textMessageOnlySpaces": "Invalid text message! A message cannot contain only whitespaces.",
      "ActiveNotificationTitle": "Activate/deactivate notification",
      "selectActiveNotification": "Only this notification will be shown to the user and all other notifications will be deactivated. Do you want to continue?",
      "deselectActiveNotification": "This notification will be deactivated and not shown to the user. Do you want to continue?",
      "successAction": "Notification successfully {action}",
      "failedAction": "Failed to {action} notification"
    }
  },
  "workloadManagement": {
    "vmCurrentResources": "Resources allocation",
    "numberOfVirtualCpus": "Number of virtual CPUs*",
    "limitMemory": "Limit memory to",
    "limitMemoryRequired": "Limit memory to*",
    "updateBtn": "Update",
    "confirmUpdate": " Do you want to proceed?",
    "updateConfirmationStatusRunningTitle": "Update resource allocation",
    "updateConfirmationStatusRunningSubtitle": "To update resource allocation the VM must be restarted. Do you want to proceed?",
    "updateConfirmationStatusStoppedTitle": "Update resource allocation",
    "updateConfirmationStatusStoppedSubtitle": "Virtual machine will remain stopped after resources are updated. Do you want to proceed?",
    "cpuNumbersMessage": "Number of CPUs must be a positive integer.",
    "invalidMemoryMessage": "Invalid format",
    "requiredMemory": "Required",
    "requiredCpu": "Number of CPU is required",
    "memoryMinValueMessage": "Min value for this measure is {value} {measure}",
    "memoryMaxValueMessage": "Max value for this measure is {value} {measure}",
    "updateResourcesMessage": "Resource update operation is in progress.",
    "memoryGBMinValueMessage": "Min value for this measure is 0.1 GB",
    "memoryKBMinValueMessage": "Min value for this measure is 100000 KB",
    "memoryMBMinValueMessage": "Min value for this measure is 100 MB",
    "memoryTBMinValueMessage": "Min value for this measure is 0.0001 TB",
    "vmBackupCreationTitle": "Creating a backup",
    "vmBackupCreationConfirmationMsg": "During backup creation the virtual machine {name} will be stopped and, if currently running, started again once the process is completed. Do you want to proceed?",
    "creatingABackupInProgress": "Backup process is in progress.",
    "localRepositoryNotConfiguredMessageTitle": "Local repository is not configured",
    "localRepositoryNotConfiguredMessageText": "The VM Backup repository is not configured. On the Local UI, go to \"Local repository\", then tap \"VM backups\" to configure repository.",
    "resourceReservationUpdated": "Resource reservation updated",
    "invalidRequestOrInsufficientResources": "Resources update can not be performed due to invalid request or insufficient resources. For more details check node log"
  },
  "nodeLogLevel": {
    "title": "Select log levels",
    "maxHours": "Max number of hours is 23",
    "maxMinutes": "Max number of minutes is 59",
    "minHours": "Min number of hours is 0",
    "minMinutes": "Min number of minutes is 0",
    "setToAllLogLevelLabel": "Log level",
    "setToAllBtn": "Set to all",
    "cancelBtn": "Cancel",
    "resetBtn": "Reset to default",
    "saveBtn": "Save",
    "setAllInfo_1": "If OVDM application does not have selected 'log level'",
    "setAllInfo_2": "the value will be set to the closest match.",
    "optionQuite": "Quite",
    "optionFatal": "Fatal",
    "optionCritical": "Critical",
    "optionError": "Error",
    "optionWarning": "Warning",
    "optionNotice": "Notice",
    "optionInformation": "Information",
    "optionDebug": "Debug",
    "optionTrace": "Trace",
    "selectTitle": " log level",
    "successfullySaved": "Log levels are successfully saved",
    "defaultConfirmMessage": "Default log levels will be immediately applied to all components. Do you want to proceed?",
    "setToDefault": "Log levels are set to default values",
    "resetToDefaultTitle": "Reset to default"
  },
  "uploadFile": {
    "uploadFile": "Upload file",
    "smallFile": "Uploaded file is smaller than 10MB.",
    "emptyFile": "Uploaded file can not be empty!",
    "wrongFileExtension": "Wrong file extension. Extension for uploaded file must be {textParams}",
    "or": " or ",
    "confirmDialogTitle": "Uploading new Docker Compose file",
    "confirmDialogSubtitle": "Please note that by uploading a new Docker Compose file, current data related to services and registries will be lost. Do you want to continue?"
  },
  "deployDetails": {
    "markTaskAsFail": "MARK AS FAILED",
    "markTaskAsSuccess": "MARK AS SUCCESSFUL",
    "feedback": "FEEDBACK",
    "errorFeedbackTitle": "Error feedback for device {device}",
    "noInformationYet": "No information yet, please check after task is finished",
    "workloadName": "Workload name",
    "workloadVersion": "Workload version",
    "operationStartTime": "Operation start time",
    "operationFinishTime": "Operation finish time",
    "type": "Type",
    "status": "Status",
    "progress": "Progress",
    "detailOfDep": "Details of deployment",
    "statusMessages": {
      "successful": "Successful",
      "inProgress": "In progress",
      "failed": "Failed"
    },
    "message": "Message",
    "troubleshooting": "Troubleshooting",
    "timeOfError": "Time of error",
    "list": {
      "emptyTaskList": "List of deployment tasks is empty.",
      "headerSerialNum": "Serial number",
      "headerProgress": "Status",
      "headerStatus": "Status",
      "headerStarted": "Started",
      "headerFinished": "Finished",
      "operationTaskList": "Operation task list",
      "headerDeviceName": "Node name"
    }
  },
  "finishTime": {
    "inProgress": "In progress"
  },
  "nodeUpdateLog": {
    "nodeUpdateLogTable": {
      "emptyList": "No node update operation was found.",
      "updateOperation": "Update operation",
      "progress": "Status",
      "started": "Started",
      "finished": "Finished"
    },
    "removeOperationTitle": "Delete log entry",
    "removeOperationSubTitle": "If this log entry is deleted, it will be removed from history.",
    "successfullyRemovedNodeUpdate": "Deletion of node update operation is successful"
  },
  "progressLinearStatus": {
    "IN_PROGRESS": "In progress",
    "FAILED": "Failed",
    "COMPLETED": "Completed",
    "ABORTED": "Aborted",
    "STOPPING": "Stopping VM",
    "ERROR": "Error",
    "DONE": "Done",
    "troubleshooting": "Troubleshooting:",
    "timeOfError": "Time of error:",
    "message": "Message:"
  },
  "vm-snapshot": {
    "list": {
      "removeSubTitle": "Are you sure you want to remove this snapshot {name}?",
      "deleteConfirm": "Delete snapshot"
    }
  },
  "vmSnapshot": {
    "name": "Name",
    "vmState": "VM state",
    "date": "Created",
    "description": "Description",
    "emptyState": "There are no snapshots to display.",
    "deleteSchedule": "Delete",
    "saveSchedule": "Save",
    "intervalTime": "Hours",
    "schedule": "Schedule",
    "scheduledDay": "Day of the Week:",
    "scheduledDayHours": "Hours:",
    "scheduledType": "Type:",
    "scheduleMessage": "Scheduled snapshots automatically replace existing snapshots.",
    "day": "Day of the week",
    "scheduleType": "Schedule Type",
    "dayHours": "Hours",
    "dayMinutes": "Minutes",
    "snapshotDialogTitle": "Create snapshot",
    "snapshotDialogCreateButton": "Create",
    "snapshotDialogCancelButton": "Cancel",
    "snapshotDialogVmStatus": "VM Status",
    "snapshotSchedule": "Snapshot Schedule",
    "dialogName": "Name",
    "type": "Type",
    "create": "Create",
    "dialogDescription": "Description",
    "dialogRequired": "Required",
    "noControlCharacter": "Control characters are not allowed",
    "removeSnapshot": "Snapshot successfully deleted.",
    "snapshotCancelButton": "Cancel",
    "snapshotTitle": "Snapshot",
    "scheduleCardTitle": "Schedule with following configuration applied",
    "scheduleVmState": "VM State",
    "snapshotButton": "Snapshot",
    "restoreSnapshot": "Restore snapshot",
    "restoreSnapshotMessage": "Snapshot successfully restored.",
    "deleteScheduleSnapshotMessage": "Snapshot schedule successfully deleted.",
    "saveScheduleSnapshotMessage": "Snapshot schedule successfully saved.",
    "saveSnapshotMessage": "Snapshot successfully saved.",
    "revertSnapshotConfirmTitle": "Revert snapshot",
    "revertSnapshotConfirmSubtitle": "By restoring this snapshot the current VM state will be lost. Are you sure you want to proceed restoring the snapshot {name}?",
    "deleteScheduleTitle": "Delete schedule",
    "deleteScheduleSubtitle": "Are you sure you want to remove the current snapshot schedule?",
    "scheduleInterval": "Interval",
    "scheduleDay": "Day",
    "scheduleDayMonday": "Monday",
    "scheduleDayTuesday": "Tuesday",
    "scheduleDayWednesday": "Wednesday",
    "scheduleDayThursday": "Thursday",
    "scheduleDayFriday": "Friday",
    "scheduleDaySaturday": "Saturday",
    "scheduleDaySunday": "Sunday",
    "scheduleDayEveryDay": "Every day",
    "scheduleCurrent": "Current",
    "scheduleStopped": "Stopped",
    "labelKeyPattern": "Only numbers, letters, space, :, +, _ and - are allowed. There can only be one space and only between the other characters, not at the beginning or at the end.",
    "testSnapshot": "Test snapshot",
    "testDescription": "Scheduled snapshot",
    "running": "running",
    "wlNameContainControlCharacter": "Invalid snapshot name! Name cannot contain control character.",
    "wlNameContainOnlySpaces": "Invalid snapshot name! Name cannot contain only whitespaces."
  },
  "nerveSimpleTable": {
    "search": "Search",
    "empty": "List of deployed workloads is empty.",
    "nodeVersionInfo": "Nodes older than 2.5.0 do not show all data due to compatibility reasons.",
    "started": "Started",
    "stopped": "Stopped",
    "suspended": "Paused",
    "error": "Error",
    "idle": "Idle",
    "removing_failed": "Removing failed",
    "n/a": "N/A",
    "restarting": "Restarting",
    "creating": "Creating",
    "removing": "Removing",
    "suspending": "Suspending",
    "starting": "Starting",
    "resuming": "Resuming",
    "stopping": "Stopping",
    "undefined": "Undefined",
    "partially_running": "Partially running",
    "noWlDeployed": "Currently there are no workloads deployed on the node.",
    "noResults": "No deployed workloads match the current filter criteria."
  },
  "vmBackups": {
    "title": "Backups",
    "name": "Name",
    "started": "Started",
    "finished": "Finished",
    "status": "Status",
    "headerProgress": "Status",
    "emptyState": "There are no backups to display.",
    "backupHistoryLog": "Backup history log",
    "saveBtn": "Create",
    "cancelBtn": "Back",
    "tableActionReset": "RETRY",
    "tableActionFeedback": "FEEDBACK",
    "backupCommand": "Backup",
    "createBackupError": "Failed to start the backup process.",
    "errorFeedbackTitle": "Error feedback",
    "noInformationYet": "No information yet, please check after the creation of backup is completed.",
    "dialogRequired": "Required",
    "labelKeyPattern": "Only numbers, letters, space, :, +, _ and - are allowed. There can only be one space and only between the other characters, not at the beginning or at the end.",
    "unit": "Unit",
    "reload": "Reload",
    "minute": "minute(s)",
    "hour": "hour(s)",
    "day": "day(s)",
    "newBackup": "New Backup",
    "wlNameContainControlCharacter": "Invalid backup name! Name cannot contain control character.",
    "wlNameContainOnlySpaces": "Invalid backup name! Name cannot contain only whitespaces."
  },
  "activeRemoteConnections": {
    "list": {
      "all": "All",
      "tunnel": "Tunnel",
      "screen": "Screen",
      "connectionName": "Name",
      "nodeName": "Node",
      "serialNumber": "Serial number",
      "acknowledgment": "ACK",
      "target": "Target",
      "user": "User",
      "tunnelScreenType": "port/type",
      "connectionType": "Connection Type",
      "emptyList": "List of active remote connections is empty.",
      "terminate": "TERMINATE",
      "terminateTitle": "Terminate remote connections",
      "terminateSubTitle": "Are you sure you want to terminate the selected connections?",
      "successfullyTerminateRemoteConnection": "Remote connections successfully terminated.",
      "nodeOffline": "Node is offline",
      "created": "Created",
      "sessionExpiration": "Session expiration"
    },
    "selectAll": "Select all",
    "btnRemove": "Remove"
  },
  "capability": {
    "showCapabilities": "Show all {numberOfCapabilities} capabilities",
    "showCapability": "Show capability",
    "nodeCapabilities": "Node Capabilities",
    "close": "Close"
  },
  "errorMessages": {
    "connection_manager_002": "File not found for the specified platform.",
    "connection_manager_003": "An unexpected error occurred while downloading the file. Please check logs for more details.", 
    "connection_manager_004": "File not found on the disk. Please trigger fetch of the latest files from NSC using the appropriate 'fetch' API endpoint.",
    "00000": "Internal server error",
    "00012": "Invalid credentials.",
    "00013": "Login failed. Please check your username and password, or activate your account if you haven't done so.",
    "00016": "Confirmation of the old password is not valid",
    "000161": "Password does not match the confirm password",
    "nerve_auth_001": "Too many failed requests made! This account or IP address has been temporarily blocked. Please try again in {textParams}",
    "nerve_auth_006": "Multi-factor authentication is disabled.",
    "nerve_auth_007": "Multi-factor authentication for this user is disabled.",
    "nerve_auth_008": "Multi-factor authentication for this user is already activated.",
    "nerve_auth_009": "Multi-factor authentication for this user is not activated.",
    "nerve_auth_010": "Temporary multi-factor authentication session does not exist.",
    "nerve_auth_011": "Invalid multi-factor authentication code.",
    "nerve_auth_012": "User with given multi-factor authentication activation/reset token not found.",
    "nerve_auth_013": "User with given multi-factor authentication reset token not found.",
    "nerve_auth_014": "User with specified activation token not found.",
    "nerve_auth_015": "User with specified password reset token not found.",
    "nerve_auth_018": "Login not possible, services are not ready yet!",
    "nerve_auth_019": "Your password has expired. Please reset your password to continue.",
    "nerve_auth_020": "Maximum number of active sessions per user reached.",
    "nerve_auth_022": "Reset credentials requests have exceeded the allowed limit for this user. The reset email was not sent. Please try again after {textParams}.",
    "nerve_auth_023": "Multi-factor authentication reset token is invalid or has expired.",
    "nerve_auth_024": "Password reset token is invalid or has expired.",
    "nerve_auth_025": "This authentication code has already been used.",
    "nerve_auth_026": "User account is not activated.",
    "nerve_unknown_err": "Unknown Error.",
    "network_error": "It appears that there is no network connection. Please check.",
    "no_connection_error": "Please log in. Session expired due to connection loss.",
    "00003": "You are not authorized",
    "000017": "The link has expired",
    "nerve_unexp_server_001": "Unexpected response received from server.",
    "nerve_unexp_server_002": "Unexpected server response while creating node.",
    "nerve_unexp_server_003": "Unexpected server response while updating node.",
    "nerve_unexp_server_004": "Unexpected server response while deploying workload.",
    "nerve_label_001": "Label with key/value already exists.",
    "nerve_label_002": "Label object invalid.",
    "nerve_label_003": "Label key is required.",
    "nerve_label_004": "Label value is required.",
    "nerve_label_005": "Label key must be string.",
    "nerve_label_006": "Label value must be string.",
    "nerve_label_007": "Allowed characters for label key are numbers, letters, _ and -",
    "nerve_label_008": "Key must have 40 characters.",
    "nerve_label_009": "Value must have 40 characters.",
    "nerve_label_010": "Merge of labels failed.",
    "nerve_label_011": "Failed to get group of keys.",
    "nerve_label_012": "Failed to get list of labels.",
    "nerve_label_013": "An error has occurred while creating label(s) and the operation failed.",
    "nerve_label_014": "An error has occurred while updating label(s) and the operation failed.",
    "nerve_label_015": "An error has occurred while deleting label(s) and the operation failed.",
    "nerve_label_016": "An error has occurred while listing labels and the operation failed.",
    "nerve_label_017": "An error has occurred while fetching labels and the operation failed.",
    "nerve_label_018": "An error has occurred while grouping labels and the operation failed.",
    "nerve_label_019": "An error has occurred while merging labels and the operation failed.",
    "nerve_label_020": "An error has occurred while checking key value of a label is unique and the operation failed.",
    "nerve_label_021": "An error has occurred while saving labels into database",
    "nerve_label_022": "Label not found",
    "nerve_label_023": "Label value invalid length",
    "nerve_label_024": "Label key invalid length",
    "nerve_label_025": "Whitespace characters are not allowed for label value.",
    "nerve_node_001": "Node with this serial number already exists.",
    "nerve_node_005": "Node with this name already exists",
    "nerve_node_006": "Label key must be unique for the node",
    "nerve_node_008": "Node object invalid!",
    "nerve_node_009": "Node with this name and serial number already exists.",
    "nerve_node_010": "Provided label does not exist.",
    "nerve_node_011": "Search parameter is not valid.",
    "nerve_node_012": "Node you are looking for does not exist.",
    "nerve_node_013": "Database error. Please contact support for further assistance.",
    "nerve_node_014": "Remote connections you are looking for do not exist!",
    "nerve_node_015": "Remote connection with this name already exists.",
    "nerve_node_016": "Input parameter must be defined.",
    "nerve_node_017": "User is not assigned to the node.",
    "nerve_node_018": "Node is offline.",
    "nerve_node_019": "Reboot action is not supported by this version of the Node",
    "nerve_node_020": "Reboot node error",
    "nerve_node_021": "Request rejected by timeout",
    "nerve_node_023": "Get logging and monitoring status operation failed",
    "nerve_node_024": "Apply logging and monitoring settings operation failed",
    "nerve_node_025": "VM video output configuration error",
    "nerve_node_026": "VM video option is not allowed on the Node",
    "nerve_node_027": "Not all required log agents are detected on the system. Please check your log agent system configuration.",
    "nerve_node_028": "Logging and monitoring feature is only supported on node version >= 2.3.0",
    "nerve_node_029": "Getting workload network interface details failed",
    "nerve_node_030": "Network interface details option is not supported by this version of the node, please use the node version >= 2.4.0",
    "nerve_node_031": "Remote connection with this name already exists.",
    "nerve_node_032": "Some error happened while deleting node.",
    "nerve_node_033": "Failed to validate node remote connection fields.",
    "nerve_node_034": "Failed to get list of nodes for deploy.",
    "nerve_node_035": "Checking if local repository is configured has failed.",
    "nerve_node_036": "Failed to create node.",
    "nerve_node_038": "Property 'serialNumber' is required.",
    "nerve_node_041": "Reboot operation failed, check backend logs for more details.",
    "nerve_node_042": " Failed to fetch node remote connections",
    "nerve_node_043": "Id of node is missing in the request",
    "nerve_node_044": "An error occurred in searching compatible nodes",
    "nerve_node_045": "An error occurred in executing of update operation.",
    "nerve_node_046": "An error occurred in executing of listing operation.",
    "nerve_node_047": "Labels that are passed should be an array.",
    "nerve_node_121": "Node cannot have more than 100 labels assigned.",
    "nerve_node_122": "Failed to import labels. Check logs for more details.",
    "nerve_node_123": "Failed to export labels. Check logs for more details.",
    "nerve_node_124": "There are no labels for node with provided serial number.",
    "nerve_node_125": "Import file is missing in the request.",
    "nerve_node_126": "Only one file is allowed for label import.",
    "nerve_node_127": "Wrong file extension",
    "nerve_node_128": "Failed to parse the uploaded label import file.",
    "nerve_node_129": "Property 'labels' is not defined in the import file.",
    "nerve_node_130": "Label import data is not valid.",
    "nerve_node_131": "File can not contain key duplicates.",
    "nerve_tree_node_000855": "Folder with that name already exists",
    "nerve_tree_node_000857": "Root node and Unassigned node can not be deleted",
    "nerve_tree_node_000858": "Request is missing required fields.",
    "nerve_tree_node_000859": "Type of field in request is invalid.",
    "nerve_exchange_000850": "Node with this serial number does not exist.",
    "nerve_exchange_000851": "User is not assigned to the node.",
    "nerve_exchange_000852": "Invalid data. Contact administrator",
    "nerve_exchange_000853": "Node can not provide data.",
    "nerve_exchange_000854": "Can not get data from cache.",
    "nerve_exchange_000871": "Node is offline.",
    "nerve_exchange_000872": "Failed to deliver data to the Node",
    "000903": "Database error. Please contact support for further assistance.",
    "nerve_rbac_001": "Failed to get LDAP roles.",
    "nerve_rbac_002": "Failed to create LDAP roles.",
    "nerve_rbac_003": "Failed to update LDAP roles.",
    "nerve_rbac_004": "Failed to assign users to roles.",
    "nerve_rbac_005": "Roles are empty or undefined.",
    "nerve_ldap_004": "Failed to read LDAP configuration.",
    "nerve_ldap_005": "Failed to update LDAP configuration.",
    "nerve_ldap_006": "Failed to check if exists active LDAP configuration.",
    "nerve_ldap_007": "LDAP user cannot be modified.",
    "nerve_ldap_008": "LDAP role cannot be modified.",
    "nerve_ldap_009": "LDAP configuration does not exist.",
    "nerve_ldap_001": "Failed to test connection.",
    "nerve_ldap_002": "Failed to query groups.",
    "nerve_ldap_003": "Failed to query users.",
    "nerve_ldap_016": "Control characters for name are not allowed.",
    "nerve_ldap_017": "Control characters for url are not allowed.",
    "nerve_ldap_018": "Port must have a value between 0 and 65536.",
    "nerve_ldap_019": "Control characters for bind DN are not allowed.",
    "nerve_ldap_020": "Password must be between 8 and 40 characters long.",
    "nerve_ldap_021": "Control characters for search base are not allowed.",
    "nerve_ldap_022": "Control characters for filter are not allowed.",
    "nerve_ldap_023": "Control characters for group name are not allowed.",
    "nerve_ldap_024": "Control characters for admin group are not allowed.",
    "nerve_ldap_025": "Control characters for default are not allowed.",
    "nerve_ldap_026": "Control characters for first name are not allowed.",
    "nerve_ldap_027": "Control characters for last name are not allowed.",
    "nerve_ldap_028": "Control characters for email are not allowed.",
    "nerve_ldap_029": "Control characters for username are not allowed.",
    "nerve_ldap_030": "Control characters for type are not allowed.",
    "nerve_ldap_031": "Control characters for membership are not allowed.",
    "nerve_ldap_032": "Control characters for target are not allowed.",
    "nerve_ldap_033": "Name should be string.",
    "nerve_ldap_034": "Url should be string.",
    "nerve_ldap_035": "Bind DN should be string.",
    "nerve_ldap_036": "Search base should be string.",
    "nerve_ldap_037": "Filter should be string.",
    "nerve_ldap_038": "Group name should be string.",
    "nerve_ldap_039": "Admin group should be string.",
    "nerve_ldap_040": "Default should be string.",
    "nerve_ldap_041": "First name should be string.",
    "nerve_ldap_042": "Last name should be string.",
    "nerve_ldap_043": "Email should be string.",
    "nerve_ldap_044": "Username should be string.",
    "nerve_ldap_045": "Type should be string.",
    "nerve_ldap_046": "Membership should be string.",
    "nerve_ldap_047": "Target should be string.",
    "nerve_ldap_048": "Failed to sync.",
    "nerve_ldap_049": "Relationship user-group is currently unsupported.",
    "nerve_ldap_050": "Unsupported relationship type.",
    "nerve_ldap_051": "Connection parameters invalid.",
    "nerve_ldap_052": "Failed to do LDAP query.",
    "nerve_ldap_053": "Failed to do LDAP query.",
    "nerve_ldap_054": "Failed to sync. Not a single user or role is created/updated.",
    "nerve_ldap_055": "Failed to change ldap activation.",
    "nerve_ldap_056": "Wrong input for TLS.",
    "nerve_ldap_057": "Wrong input for recurring sync.",
    "nerve_ldap_058": "Wrong value for recurring sync schedule.",
    "nerve_ldap_059": "Wrong value for recurring sync time.",
    "nerve_ldap_060": "Invalid credentials.",
    "nerve_ldap_061": "LDAP server is unavailable.",
    "nerve_ldap_062": "To activate this configuration, at least one admin user must exist.",
    "nerve_ldap_063": "LDAP admin group not found.",
    "nerve_ldap_064": "Failed to get all LDAP configurations.",
    "nerve_ldap_065": "If there is not one LDAP configuration file saved, synchronization will not be possible.",
    "nerve_ldap_066": "Triggered action is already in progress.",
    "00004": "Not found",
    "00017": "Password pattern is not valid",
    "000880": "Something went wrong with canceling connection",
    "nerve_notification_001": "Database error. Please contact support for further assistance.",
    "nerve_notification_002": "Notification you are looking for does not exist!",
    "nerve_notification_003": "Control characters for header text are not allowed.",
    "nerve_notification_004": "Control characters for text message are not allowed.",
    "nerve_notification_005": "Header text should be string.",
    "nerve_notification_006": "Text message should be string.",
    "nerve_notification_007": "Wrong input for showBeforeLogin field.",
    "nerve_notification_008": "Wrong input for active field.",
    "nerve_notification_009": "Header text is required.",
    "nerve_notification_010": "Text message is required.",
    "nerve_notification_011": "Header text can contain up to 60 characters.",
    "nerve_notification_012": "Text message can contain up to 10000 characters.",
    "nerve_notification_013": "Failed to create directory.",
    "nerve_notification_014": "Failed to move image to directory.",
    "nerve_notification_016": "Notification data is not valid against the schema. Please check server logs for details.",
    "nerve_notification_017": "Invalid text message. Text message cannot contain only HTML tags.",
    "nerve_notification_018": "Invalid header text. Header text cannot contain only whitespace characters.",
    "nerve_notification_019": "Invalid text message. Text message cannot contain only whitespace characters.",
    "nerve_workload_configuration_001": "Workload configuration file type not supported.",
    "nerve_workload_configuration_002": "Failed to upload file.",
    "nerve_workload_configuration_003": "Apply configuration procedure failed.",
    "nerve_workload_configuration_004": "Serial is not defined.",
    "nerve_workload_configuration_005": "Device id is not defined",
    "nerve_workload_configuration_006": "Payload not defined.",
    "nerve_workload_configuration_007": "Workload configuration file is missing.",
    "nerve_workload_configuration_008": "Initiator is missing.",
    "nerve_workload_configuration_009": "Apply procedure action is missing or not supported.",
    "nerve_workload_configuration_010": "Volume data are missing.",
    "nerve_workload_configuration_011": "Volume name or path are missing.",
    "nerve_workload_configuration_012": "Restart on configuration update field is missing.",
    "nerve_workload_configuration_013": "Failed to generate configuration file download link.",
    "nerve_workload_configuration_014": "Apply configuration procedure failed. Check serial.",
    "nerve_workload_configuration_015": "Workload for which configuration update is requested does not exist on the system.",
    "nerve_workload_configuration_016": "Configuration update request is not valid, there are some information missing. Please contact support team.",
    "nerve_workload_configuration_017": "Workload configuration is in invalid format.",
    "nerve_workload_configuration_018": "Configuration update is only supported for docker and Docker Compose workloads.",
    "nerve_workload_configuration_019": "Configuration update is not possible for workload that is in REMOVING or REMOVING_FAILED status.",
    "nerve_workload_configuration_020": "Workload for which configuration update is deployed without configuration information. Configuration update is not possible. Please re-deploy workload with configured configuration fields.",
    "nerve_workload_configuration_021": "Configuration fields defined when workload was deployed does not match configuration fields in the request. If you are using API to update configuration please check that configuration fields match expected values.",
    "nerve_deploy_workload_010": "Cannot deploy workload, provided workload version is not deployable.",
    "nerve_deploy_workload_008": "Deployment with provided id was not found",
    "nerve_deploy_workload_007": "Deployment with provided name already exist, please change name of deployment",
    "nerve_deploy_workload_006": "Deploy name must be less than 40 characters.",
    "nerve_deploy_workload_005": "One of the selected nodes doesn't exist.",
    "nerve_deploy_workload_004": "Cannot deploy workload. Node list not defined.",
    "nerve_deploy_workload_003": "Deploy name field must be of maximum length 40 and cannot contain special characters except _:,()- and .",
    "nerve_deploy_workload_001": "Cannot deploy workload. Workload was deleted.",
    "nerve_roles_001": "Role does not exist!",
    "nerve_roles_002": "Main request parameters not present.",
    "nerve_roles_003": "Role is missing required fields.",
    "nerve_roles_004": "Database error. Please contact support for further assistance.",
    "nerve_roles_005": "Permission you are looking does not exist!",
    "nerve_roles_006": "Role with that name already exist!",
    "nerve_roles_007": "Delete method is not allowed! Role is assigned to one or more users.",
    "nerve_roles_008": "Role must have at least one permission granted.",
    "nerve_roles_009": "Maximum length for role description is 64 characters.",
    "nerve_roles_010": "Default role cannot be modified.",
    "nerve_roles_011": "Role name is required.",
    "nerve_roles_012": "Role description is required.",
    "00006": "Route params validation error.",
    "000721": "User not found.",
    "000711": "Version with this name/release_name already exists",
    "svc_0001": "Redis service is currently unavailable, please contact the administrator",
    "svc_0002": "MongoDB is currently unavailable, please contact the administrator",
    "svc_0003": "EMQ (MQTT broker) is currently unavailable, please contact the administrator",
    "svc_0004": "Contact the Administrator as the following services are unavailable: ",
    "svc_0005": "RabbitMQ service is currently unavailable, please contact the administrator",
    "svc_0006": "Failed to establish connection - Chisel service is currently unavailable, please contact the administrator",
    "svc_0007": "Failed to establish connection - Guacamole DB is currently unavailable",
    "svc_0008": "Failed to establish connection - Guacamole service is currently unavailable",
    "000700": "Workload you are looking for does not exist.",
    "000702": "Workload with this name already exists.",
    "000703": "Workload version you are looking for does not exist.",
    "nerve_workload_045": "Undeploy failed. Please check logs for more details.",
    "nerve_workload_046": "Getting virtual machine snapshot failed.",
    "nerve_workload_047": "Creating VM snapshot failed.",
    "nerve_workload_048": "Deleting VM snapshot failed.",
    "nerve_workload_049": "Reverting VM snapshot failed.",
    "nerve_workload_050": "Failed to schedule snapshot creation.",
    "nerve_workload_051": "Failed to remove schedule snapshot configuration.",
    "nerve_workload_052": "Snapshot name is not set.",
    "nerve_workload_053": "VM snapshot feature is supported on node version >= 2.4.0.",
    "nerve_workload_054": "Snapshot schedule type invalid.",
    "nerve_workload_055": "Interval time invalid.",
    "nerve_workload_056": "Schedule day invalid.",
    "nerve_workload_057": "Schedule day time invalid.",
    "nerve_workload_058": "VM state invalid.",
    "nerve_workload_059": "Schedule type is mandatory.",
    "nerve_workload_060": "Schedule type should be string.",
    "nerve_workload_061": "Interval time is mandatory.",
    "nerve_workload_062": "Schedule day is mandatory.",
    "nerve_workload_063": "Schedule day should be string.",
    "nerve_workload_064": "Day time is mandatory.",
    "nerve_workload_065": "Day time should be string in format hh:mm.",
    "nerve_workload_066": "VM state is mandatory.",
    "nerve_workload_067": "VM state should be string.",
    "nerve_workload_068": "Time zone is mandatory.",
    "nerve_workload_069": "Time zone should be string.",
    "nerve_workload_070": "Time zone is invalid.",
    "nerve_workload_071": "Time zone offset is mandatory.",
    "nerve_workload_072": "Time zone offset should be string in format e.g. +2.",
    "nerve_workload_073": "Time zone offset is invalid.",
    "nerve_workload_074": "Interval time should be number.",
    "nerve_workload_075": "Interval time should be Integer.",
    "nerve_workload_083": "Modifications are limited to selectors and remote connections for the released workloads.",
    "nerve_workload_076": "Snapshots are only possible for VM with QCOW2 image",
    "nerve_workload_077": "Workload is invalid, please contact support",
    "SNAPSHOT_CREATION_FAILED_NO_SPACE_LEFT_ON_DEVICE": "Snapshot creation failed, no space left on device",
    "WORKLOAD_VM_IMG_CONVERSION_ERROR": "There was an error while converting the last specified VM image",
    "WORKLOAD_DOCKER_IMG_DOWNLOAD_ERROR": "There was an error while downloading Docker image",
    "WORKLOAD_SOME_DOCKER_IMG_DOWNLOAD_ERROR": "There was an error while downloading some of the Docker images.",
    "WORKLOAD_DOCKER_IMG_LOGIN_ERROR": "Docker image: Failed to login to the Docker registry. Please check your credentials!",
    "WORKLOAD_VM_IMG_CONVERTED_SUCCESSFULLY": "A VM image has been converted and set up successfully",
    "WORKLOAD_DOCKER_IMG_DOWNLOADED_SUCCESSFULLY": "A Docker image has been downloaded and set up successfully",
    "EXPORT_READY_FOR_DOWNLOAD": "Exported archive is ready for download.",
    "nerve_workload_140": "The workload cannot be undeployed, a backup is in progress.",
    "000868": "Invalid property value!",
    "nerve_workload_124": "Snapshot option is not enabled",
    "nerve_workload_125": "There is already created snapshot for that VM. Just one snapshot is possible per VM",
    "nerve_workload_126": "VM workload is not present on the system",
    "nerve_workload_127": "Snapshot operations are not allowed on the node",
    "nerve_workload_128": "VM backup operations are not allowed on the node",
    "nerve_workload_129": "Backup operation is not supported to that workload type",
    "nerve_workload_130": "Backup is not possible until the previous one is complete",
    "nerve_workload_131": "Backup is not possible at the moment, the node update is in progress",
    "nerve_workload_132": "Backup with provided name already exists",
    "nerve_workload_133": "Backup restart is not possible until the previous one is completed",
    "nerve_workload_134": "Backup restart is not possible at the moment, the node update is in progress",
    "nerve_workload_135": "Only a backup with a failed status may be restart",
    "nerve_workload_136": "VM backup repository is not configured",
    "nerve_workload_137": "There are not backups for this workload",
    "nerve_workload_138": "There is no backup with provided name",
    "nerve_workload_153": "Missing uploaded files for creation of a docker workload or the uploaded files do not match the names in the provided payload.",
    "nerve_workload_155": "Workload configuration cannot be edited while download is in progress.",
    "VM_BACKUP_IS_IN_PROGRESS_CANNOT_BE_STARTED": "The workload cannot be started, a backup is in progress.",
    "usage_report_001": "Something went wrong during usage report generation.",
    "usage_report_002": "Something went wrong during report object and dates creation.",
    "usage_report_003": "Something went wrong during yaml file creation for usage report.",
    "usage_report_004": "Something went wrong during configuration creation.",
    "usage_report_005": "Something went wrong during configuration parameters update.",
    "usage_report_006": "Can't generate usage report for this date.",
    "usage_report_007": "Can't retrieve date when instance is spawned.",
    "nerve_workload_141": "VM backup option is supported on node version >= 2.4.0",
    "nerve_workload_142": "Failed to fetch VM backup logs",
    "nerve_workload_143": "Failed to create backup for VM",
    "nerve_workload_144": "VM backup name is required",
    "nerve_workload_145": "VM backup repository is not configured",
    "nerve_workload_146": "Failed to restart backup for VM workload",
    "nerve_workload_147": "Failed to create a mount point.",
    "nerve_workload_148": "Nfs server is not active.",
    "nerve_workload_149": "Docker volume name and path can only contain numbers, letters and characters '-', '.' and '_'. Docker path has to start with '/'.",
    "nerve_workload_auth_001": "Token is not valid.",
    "nerve_workload_auth_002": "Missing authorization data.",
    "nerve_workload_auth_003": "Authorization failed for unknown reason.",
    "000862": "Remote connection you are looking for does not exist",
    "000881": "Remote connection you are looking for does not exist",
    "000879": "Corrupted image file or wrong extension. Allowed extensions: img, raw, qcow2, zip, img.gz, raw.gz, qcow2.gz",
    "001005": "Can't do the action because last or current version is not deployable",
    "000866": "Username or Password is invalid!",
    "000869": "Username is missing for defined docker registry.",
    "000870": "Password is missing for defined docker registry.",
    "000876": "Wrong file entry in zip file.",
    "000722": "Provided docker registry not supported.",
    "000723": "Docker path not found.",
    "000724": "Docker image: Failed to login to the Docker registry.",
    "000725": "Docker image: Failed to logout from the Docker registry.",
    "000726": "Docker image: Failed to pull docker image from a registry.",
    "000727": "Docker image: Failed to save docker image to tar archive.",
    "000728": "Docker image: Failed to remove docker image.",
    "000729": "Docker image: Failed to inspect docker image.",
    "000730": "Docker image: The provided credentials are invalid.",
    "000731": "Docker image: Invalid repository name.",
    "000732": "Docker image: Failed to remove docker image.",
    "nerve_workload_156": "Cannot delete released version.",
    "nerve_workload_159": "Cannot delete version for which download of the files is in progress.",
    "nerve_remote_connection_1": "Invalid data provided. The 'rcList' property is required.",
    "nerve_remote_connection_5": "Failed to generate a list of unique names.",
    "nerve_remote_connection_6": "Failed to generate a list of unique names. Check your payload.",
    "nerve_remote_connection_7": "Missing data that defines the target for the remote connection. Check your payload.",
    "nerve_remote_connection_10": "Missing file.",
    "nerve_remote_connection_11": "Multiple files, only one file per request can be uploaded.",
    "nerve_remote_connection_12": "Invalid file name - file name must not contain control characters and should be up to 90 characters in length.Allowed extensions are .yaml or .yml.",
    "nerve_remote_connection_13": "Invalid target data provided.",
    "nerve_remote_connection_14": "Failed to parse remote connection yaml file. Please make sure the file is a valid yaml file.",
    "nerve_remote_connection_15": "File format does not match schema. See documentation for correct formatting guidelines.",
    "nerve_remote_connection_16": "File format does not match schema. Password for VNC type connection is missing.",
    "nerve_remote_connection_17": "File format does not match schema. Remote connection list is missing.",
    "nerve_remote_connection_18": "You have exceeded the maximum number of connection requests allowed.",
    "nerve_remote_connection_19": "An error occurred while creating the remote connection.",
    "nerve_remote_connection_20": "An error occurred while editing the remote connection.",
    "nerve_remote_connection_21": "An error occurred while deleting the remote connection.",
    "nerve_workload_162": "There are no files for the specified workload version.",
    "nerve_workload_163": "Workload version is already created, therefore the version creation cannot be canceled.",
    "nerve_workload_164": "Workload data is not valid against the schema. Please check server logs for details.",
    "nerve_workload_165": "Workload that you are trying to delete does not exist.",
    "nerve_workload_166": "Failed to finalize request, unexpected error occurred.",
    "nerve_workload_167": "Action is not supported for provided workload type. The V3 API for workloads/versions/files is available only for Docker Compose workload type(other workload types are not supported yet).",
    "nerve_workload_168": "There are no files defined for specified workload version. File list empty.",
    "nerve_workload_169": "There is no file with specified file id. Please check your file id in the request API.",
    "nerve_workload_170": "Workload version is marked as released, requested action is not possible.",
    "nerve_workload_171": "An unexpected error occurred while performing the operation.",
    "nerve_workload_172": "The remote connection name in the provided list is not unique.",
    "nerve_workload_173": "Only selectors and remote connections change is allowed for the released workload version.",
    "nerve_workload_174": "All files for workload version are already uploaded, please use DELETE or PATCH routes if you want to update uploaded files.",
    "nerve_workload_175": "Wrong 'file' field in the API request. Value of 'file' field needs to be 'file' when file is uploaded.",
    "nerve_workload_176": "Failed to save file. Please check that your file is not corrupted or with bad extension.",
    "nerve_workload_177": "Failed to add/edit file to workload version. File not uploaded. Please check that file is not missing in your API request.",
    "nerve_workload_179": "Failed to add/edit file to workload version. Value of 'source' field in the API request needs to match file field name.",
    "nerve_workload_180": "Failed to add/edit file to workload version. Value of 'origin' field in the API request needs to be 'upload' when file is uploaded. When not uploading file, 'clone' or 'docker-repo' should be used.",
    "nerve_workload_181": "Failed to add/edit file to workload version. Value of 'type' field in the API request needs to be 'compose' or 'docker-image'.",
    "nerve_workload_182": "Failed to add/edit file to workload version. Value of 'type' field in the API request needs to match uploaded file extension.",
    "nerve_workload_183": "Failed to add file to workload version. File type already exist in the list of files. Please check your API request. You can also update or delete existing file.",
    "nerve_workload_184": "Failed to add/edit file. When there is no file uploaded and 'type' field is set to 'compose', value of 'origin' field needs to be 'clone'. Please check your API request.",
    "nerve_workload_185": "Failed to cancel file download. File is not in downloading status, cancel action is not possible.",
    "nerve_workload_186": "Failed to cancel all file downloads. There are no files in downloading status.",
    "nerve_workload_187": "Failed to update file. File with specified id does not exist.",
    "nerve_workload_188": "Failed to add/edit file. File id defined in the 'source' field that should be cloned, does not exist. Please check 'source' field value in your API request.",
    "nerve_workload_189": "It is not possible to clone file that has different file type. Please check 'source' and 'type' filed values in your API request.",
    "nerve_workload_190": "Failed to add/update file. File id defined in the 'source' field that should be cloned is not available'. You can only clone files with status 'available'. Please check 'source' field value in your API request.",
    "nerve_workload_191": "Failed to add/update file. When updating file, type of the file can not be changed. Please check 'type' field value in your API request.",
    "nerve_workload_192": "Missing file.",
    "nerve_workload_193": "Multiple files, only one file per request can be uploaded.",
    "nerve_workload_194": "Wrong file extension, allowed extensions are .yaml or .yml.",
    "nerve_workload_195": "Failed to parse Docker Compose yaml file. Please make sure the file is a valid yaml file.",
    "nerve_workload_196": "Missing Docker Compose schema in the predefined directory.",
    "nerve_workload_197": "Failed to fetch available Docker Compose schemas from the predefined directory.",
    "nerve_workload_198": "Missing Docker Compose schema file. Please contact Nerve Support.",
    "nerve_workload_199": "Failed to load Docker Compose schema file. Please contact Nerve Support",
    "nerve_workload_200": "Invalid schema file.",
    "nerve_workload_201": "Provided Docker Compose file failed the validation against Docker Compose schema. Please refer to the user documentation for details about the schema validator to make sure your file complies with the schema.",
    "nerve_workload_202": "Provided Docker Compose file is not valid, only one service can be specified.",
    "nerve_workload_203": "File is not Docker Compose file.",
    "nerve_workload_204": "File not available. File status indicates file not available (download in progress or creation cancelled).",
    "nerve_workload_205": "Failed to read Docker Compose file, an unexpected error occurred.",
    "nerve_workload_206": "Failed to edit file. Edit is not possible when file is in 'downloading' status.",
    "nerve_workload_209": "Failed to define all version files. Provided list of files does not match uploaded Docker Compose file. All different docker images from Docker Compose file needs to be defined in the files list.",
    "nerve_workload_210": "Provided Docker Compose file is not valid. There are services with missing image names.",
    "nerve_workload_211": "Failed to define version files. Provided list of files has duplicated docker images. Please be aware that default tag for images without tag is 'default'.",
    "nerve_workload_218": "This workload cannot be deployed to the node(s) [{textParams}]. The reported node(s) can only manage single-service Docker Compose workloads.",
    "nerve_workload_219": "Archive content is not expected one. Possible that some expected files are missing or there are some suspicious or not expected files.",
    "nerve_workload_220": "Error happened during workload file upload, please check logs for more details.",
    "nerve_workload_221": "Vm file in the archive exceeds file size limit defined.",
    "nerve_workload_231": "Workload for which Docker Compose is uploaded uses internal Docker registry. All images in the Docker Compose file need to start with registry url.",
    "nerve_workload_245": "Export of the version is already in progress. The new export cannot be initiated.",
    "nerve_workload_247": "Export version is in progress, updating version is not possible.",
    "nerve_workload_248": "Export version is in progress, deletion of WL or Version is not possible.",
    "nerve_workload_249": "This action is not allowed while the DNA is in the Reconfiguring state.",
    "nerve_workload_250": "This action is not allowed while the DNA is in the Canceling state.",
    "nerve_workload_251": "Provided Docker Compose file is not valid. There are services with invalid image names.",
    "nerve_workload_253": "The uploaded archive was rejected due to safety concerns. The file may be a GZIP bomb or otherwise unsafe.",
    "nerve_workload_254": "Provided docker compose file is not valid. Nerve does not support the usage of environment variables in image names.",
    "nerve_deploy_workload_011": "Can not deploy workload, node with provided serial number is not online or workload version and node labels do not match.",
    "nerve_deploy_workload_014": "The workload is disabled and cannot be deployed.",
    "update_service_004": "Failed to fetch available versions. Network is unavailable.",
    "update_service_005": "Failed to fetch available versions. Couldn't access Nerve software center.",
    "update_service_006": "Failed to fetch current cloud version. Please check logs for more details.",
    "update_service_007": "Failed to fetch incompatible nodes. Please check logs for more details.",
    "nerve_dna_001": "File upload failed.",
    "nerve_dna_003": "You are not authorized.",
    "nerve_dna_004": "You are missing permission.",
    "nerve_dna_006": "Configuration operation failed for unknown reason.",
    "nerve_dna_007": "Unable to apply configuration operation, as re-configuration is in-progress.",
    "nerve_dna_008": "The node with specified serial number is not available.",
    "nerve_dna_009": "The serial number of the node is not defined.",
    "nerve_dna_014": "The file type is not supported.",
    "nerve_dna_016": "Not all workloads are provisioned.",
    "nerve_dna_017": "Uploaded configuration is not valid.",
    "nerve_dna_018": "The current configuration cannot be downloaded while node is being reconfigured.",
    "nerve_dna_019": "Only nodes with version 2.7.0 and greater can continue DNA reconfiguration.",
    "nerve_dna_020": "There can be only one CODESYS workload.",
    "nerve_dna_021": "Workload deployment failed, there is no available CPU resources.",
    "nerve_dna_022": "While certain processes are occurring on the node, the execution of DNA actions is prohibited.",
    "nerve_dna_023": "Node can only manage single-service Docker Compose workloads.",
    "nerve_dna_025": "The provided filename does not match the required format.",
    "nerve_dna_026": "Cannot re-apply configuration, no previous dna configuration.",
    "nerve_dna_027": "Archive content is not expected one. Possible that some expected files are missing or there are some suspicious or not expected files.",
    "nerve_dna_028": "Node capabilities does not support the deployment of the workload.",
    "nerve_dna_029": "Signed DNA files can only be applied on nodes with version >= 3.1.0",
    "nerve_dna_030": "Signature verification failed.",
    "nerve_dna_031": "Uploaded configuration not valid - Required hashes are missing for one or more workloads.",
    "nerve_dna_032": "DNA target file - Invalid signature.",
    "nerve_dna_034": "Configuration operation failed for unknown reason. Please check logs for more details",
    "nerve_dna_036": "The provided file is not a valid YAML file.",
    "nerve_dna_037": "Uploaded configuration is not valid against the schema. Please check logs for more details.",
    "nerve_dna_041": "Network interfaces defined in the DNA file do not match the existing interfaces on the node.",
    "nerve_dna_042": "Some network interfaces are missing in the DNA file. Please check available network interfaces and update the DNA file accordingly.",
    "nerve_dna_043": "WAN interface DNS-2 requires DNS-1 to be defined in the DNA file.",
    "nerve_dna_044": "WAN interface DNS-3 requires DNS-1 and DNS-2 to be defined in the DNA file.",
    "nerve_dna_045": "Non-WAN interfaces cannot have DNS or Disabled-Traffic properties defined in the DNA file.",
    "nerve_dna_046": "Only one network interface can be set to use DHCP",
    "nerve_dna_047": "Unable to apply node DNAconfiguration, as another configuration is in-progress.",
    "nerve_dna_048": "Unable to apply node DNA configuration, as network settings update is in-progress.",
    "nerve_dna_049": "Unable to apply node DNA configuration, as proxy settings update is in-progress.",
    "nerve_dna_050": "Defined time zone is not supported on the node. Please check documentation for the list of supported time zones.",
    "nerve_dna_051": "Unable to apply Node DNA configuration because the node production mode is in the reconfiguration process.",
    "nerve_dna_052": "Wan interface requires Gateway to be defined in the DNA file.",
    "nerve_dna_053": "Wan interface requires Disabled-Traffic to be defined in the DNA file.",
    "nerve_dna_055": "The provided file is not a valid YAML file.",
    "nerve_dna_056": "No space available for workload files.",
    "nerve_dna_057": "The DNA file cannot be signed because it does not contain any workloads.",
    "nerve_dna_058": "Proxy settings have changed so the Username and Password fields are required in the DNA file.",
    "nerve_dna_059": "Uploaded configuration is not valid. A metadata key has to be unique.",
    "nerve_dna_060": "Failed to calculate combined hash and sign the DNA file.",
    "nerve_sos_dna_031": "WAN interface DNS-3 requires DNS-2 to be defined in the DNA file.",
    "nerve_sos_dna_046": "Uploaded configuration is not valid. A metadata key has to be unique.",
    "nerve_sos_dna_047": "TPM2 is supported on the node, so it must be defined in the DNA file.",
    "nerve_sos_dna_048": "TPM2 is not supported on the node, so it must not be defined in the DNA file.",
    "nerve_sos_dna_049": "WAN interface using DHCP or unused cannot have IP-Address, Mask, Gateway or DNS-1, DNS-2, DNS-3 defined in the DNA file.",
    "nerve_sos_dna_050": "WAN interface using static assignment requires IP-Address and Mask to be defined in the DNA file.",
    "nerve_sos_dna_051": "WAN interface using static assignment requires DNS-1 to be defined in the DNA file.",
    "nerve_sos_dna_052": "Non-WAN interface using static assignment requires IP-Address and Mask to be defined in the DNA file.",
    "nerve_sos_dna_053": "Non-WAN interface using DHCP or unused cannot have IP-Address or Mask defined in the DNA file.",
    "nerve_sos_dna_054": "Could not apply logging and monitoring configuration due to beats being unavailable at the moment. Please try again later.",
    "nerve_sos_dna_055": "Node DNA configuration failed in verification phase, please check the additional information for details.",
    "nerve_node_053": "Failed to get activity logs from open search.",
    "nerve_node_054": "Something went wrong during generation csv file.",
    "nodeOffboarded": "Node with serial number {serialNumber} has been offboarded from this Management System.",
    "nodeRemovedFromSystem": "Node with serial number {serialNumber} has been removed from this Management System.",
    "serviceNameNotDefinedRc": "Connection cannot be established because the service is not defined in the Docker Compose file.",
    "nerve_docker_registry_002": "Image was not found on the registry.",
    "nerve_docker_registry_003": "Image can not be deleted at the moment, it is used by released workload version.",
    "nerve_docker_registry_004": "The operation is unsupported.",
    "nerve_node_065": "Node cannot be removed while DNA is reconfiguring or configuration is being cancelled.",
    "nerve_node_066": "Failed to delete unused docker images from the node. Please check logs for more details.",
    "nerve_node_067": "Action cannot be performed while unused Docker images are being removed.",
    "nerve_node_068": "Removal od unused docker images is already in progress.",
    "nerve_node_069": "Removing unused docker images is not possible at the moment: workload installation in progress.",
    "nerve_node_070": "Removing unused docker images is not possible at the moment: node update in progress.",
    "nerve_node_071": "Removing unused docker images is not possible at the moment: dna is reconfiguring",
    "nerve_node_072": "Docker daemon is not running on the node.",
    "nerve_node_073": "Failed to list Docker volumes. Please check logs for more details.",
    "nerve_node_074": "Managing docker resources (volumes, unused images) is only supported on node version >= 2.10.0.",
    "nerve_node_075": "Failed to delete Docker volume. Please check logs for more details.",
    "nerve_node_076": "Volume with specified name does not exist on the system.",
    "nerve_node_077": "Volume with specified name is used by a container and cannot be removed.",
    "nerve_node_078": "SecureId must be updated when the serial number changes.",
    "nerve_node_079": "Failed to write file to the destination.",
    "nerve_node_080": "Archive size exceeds maximum allowed size.",
    "nerve_node_081": "Uploaded file must be a .zip archive.",
    "nerve_node_082": "Volume import aborted.",
    "nerve_node_083": "Invalid data provided for volume import.",
    "nerve_node_084": "Failed to import data to Docker volume. Please check logs for more details.",
    "nerve_node_085": "Volume with specified name is not mounted on the system.",
    "nerve_node_086": "There is not enough space on the system.",
    "nerve_node_087": "Import not possible. Failed to read zip file.",
    "nerve_node_088": "Import not possible. Directory depth exceeds the limit.",
    "nerve_node_089": "Action is not possible while import to volume is in progress.",
    "nerve_node_090": "Import not possible. Failed to open zip file.",
    "nerve_node_091": "Failed to initiate Docker volume export. Please check logs for more details.",
    "nerve_node_092": "Import not possible. Failed to extract zip file.",
    "nerve_node_093": "Export of selected volume is already in progress.",
    "nerve_node_094": "Not allowed request. Backup info not found on the MS side.",
    "nerve_node_095": "Missing required parameters in the request.",
    "nerve_node_096": "Failed to upload Docker volume backup archive from node. Please check logs for more details.",
    "nerve_node_097": "Failed to process docker data after file was uploaded.",
    "nerve_node_098": "Docker volume mount point is empty.",
    "nerve_node_099": "Export not possible. Volume size exceeds the 10GB maximum allowed limit.",
    "nerve_node_144": "Export timed out because no updates were received from the node for too long.",
    "nerve_node_145": "Import timed out because no updates were received from the node for too long.",
    "nerve_node_100": "Import not possible. CRC32 missing for some of the files.",
    "nerve_node_101": "Import not possible. CRC32 mismatch for some of the files.",
    "nerve_node_102": "Action is not possible while export of volume is in progress.",
    "nerve_node_103": "Docker volume export is not in progress.",
    "nerve_node_104": "Docker volume export creation cancelled.",
    "nerve_node_105": "Failed to cancel Docker volume export. Please check logs for more details.",
    "nerve_node_106": "Volume import has been cancelled.",
    "nerve_node_107": "Volume import is not in progress.",
    "nerve_node_108": "Volume import cannot be cancelled while extraction of files to the volume is in progress unless status has not been updated for at least 5 minutes.",
    "nerve_node_109": "Failed to cancel Docker volume import. Please check logs for more details.",
    "nerve_node_110": "Failed to perform Redis operation. Please check logs for more details.",
    "nerve_node_111": "Size of the downloaded archive does not match size of the archive.",
    "nerve_node_112": "Import not possible. Zip archive is empty.",
    "nerve_node_113": "Serial number is not correct. It must be a string.",
    "nerve_node_114": "Production mode is not correct. It must be a boolean value.",
    "nerve_node_115": "Failed to set production mode. Please check logs for more details",
    "nerve_node_116": "Production mode is not supported on this node. No capability reported.",
    "nerve_node_117": "Node DNA configuration is in progress. Please try again later.",
    "nerve_node_143": "Import not possible. Zip archive is corrupted or malformed.",
    "defaultError": "Something went wrong. Please check logs for more details.",
    "session_expired": "Session expired. Please log in again.",
    "strat_crm_001": "Failed to get LDAP profiles.",
    "strat_crm_002": "Failed to create LDAP profiles.",
    "strat_crm_003": "Failed to update LDAP profiles.",
    "strat_crm_004": "Failed to assign roles to profiles.",
    "strat_crm_005": "Array is empty or not defined.",
    "strat_crm_006": "Failed to delete profiles.",
    "strat_crm_007": "Failed to unassign LDAP role from users.",
    "strat_crm_008": "Failed to delete roles.",
    "strat_crm_009": "The last admin user cannot be deleted, and the role for the same user cannot be changed.",
    "strat_crm_010": "The specified user does not exist.",
    "strat_crm_011": "Changing password process requires current password, new password and confirmation password fields.",
    "strat_crm_012": "You used an old password. To protect your account, choose a new password.",
    "strat_crm_013": "Contact already in use",
    "strat_crm_014": "The request has an invalid payload. Please check the API documentation for the expected format.",
    "strat_crm_015": "You cannot change password for other accounts.",
    "strat_crm_016": "Profile image URL is in invalid format.",
    "strat_crm_017": "Profile image URL must be a string.",
    "strat_crm_018": "One or more selected label keys do not exist.",
    "strat_crm_019": "Function arguments are invalid.",
    "strat_crm_020": "Failed to get profile. For more details please check logs.",
    "strat_crm_021": "Profile registration failed. Please check logs for more details.",
    "strat_crm_022": "Profile update failed. Please check logs for more details.",
    "strat_crm_023": "Mail you are searching for does not exist",
    "strat_crm_024": "Profile deletion failed. Please check logs for more details.",
    "strat_crm_025": "Personal profile update failed. Please check logs for more details.",
    "strat_crm_026": "Failed to list user profiles. Please check logs for more details.",
    "strat_crm_028": "An access token with this name already exists for the authenticated user.",
    "strat_crm_029": "The authenticated user already has the maximum number of active access tokens.",
    "strat_crm_030": "Access token creation failed. Please check logs for more details.",
    "strat_crm_031": "The provided expiration date exceeds the maximum allowed token lifetime.",
    "strat_crm_032": "At least one requested permission does not exist.",
    "strat_crm_033": "Access token not found.",
    "strat_crm_034": "Access token revoke failed. Please check logs for more details.",
    "strat_crm_035": "Access token deletion failed. Please check logs for more details.",
    "strat_crm_037": "The authenticated user has reached the maximum number of total access tokens. Please delete some existing tokens to create new ones.",
    "strat_crm_038": "Failed to list access tokens. Please check logs for more details.",
    "000768": "Unable to upload file. Please check that archive is in correct format.",
    "nerve_conflicting_action_001": "Node DNA configuration is in progress. Action is blocked.",
    "nerve_conflicting_action_002": "Factory reset is in progress. Action is blocked.",
    "nerve_conflicting_action_003": "Node update is in progress. Action is blocked.",
    "nerve_conflicting_action_004": "Production mode update is in progress. Action is blocked.",
    "nerve_conflicting_action_005": "Proxy settings update is in progress. Action is blocked.",
    "nerve_conflicting_action_006": "Network settings update is in progress. Action is blocked.",
    "nerve_conflicting_action_007": "Logging or monitoring configuration is in progress. Action is blocked.",
    "nerve_conflicting_action_008": "Action is not possible when DNA is in reconfiguration state.",
    "nerve_conflicting_action_009": "Action is not possible when DNA is in cancellation state.",
    "nerve_conflicting_action_010": "Action not allowed while removal of unused Docker images is in progress.",
    "nerve_conflicting_action_011": "Action not allowed while integrity check is in progress.",
    "nerve_campaign_service_008": "Task cannot be marked as failed because it is already finished.",
    "nerve_campaign_service_009": "Task cannot be marked as successful because it is already finished.",
    "nerve_campaign_service_010": "Task cannot be marked as finished because it is already finished."
  },
  "dockerComposeRegistry": {
    "errorMessageWhenImageIsNotAvailable": "Image is not available on Management System Registry",
    "internalDockerRegistry": "Management System Registry",
    "legacyStorage": "Legacy storage",
    "storage": "Storage preference",
    "defaultValue": "Default",
    "status": "Status",
    "deployable": "Ready to deploy",
    "notDeployable": "Workload not deployable",
    "errorMessageWhenWlIsNotDeployable": "Images are not available on Management System Registry",
    "serviceName": "Service name",
    "downloadArchive": "Download archive({date}):",
    "re-pack": "Re-pack for the latest data"
  },
  "managementSystemRegistry": {
    "repositories": "Repositories",
    "emptyRepositories": "There are no repositories to display",
    "tags": "Tags",
    "emptyTag": "There are no tags to display",
    "digest": "Digest",
    "successfullyDeleted": "Registry tag successfully deleted",
    "deleteConfirm": "Delete image tag",
    "removeSubTitle": "Are you sure you want to delete the [{tag}] tag from the [{name}] Docker image?",
    "removeSubTitleWhenTagsWithSameDigest": "Are you sure you want to delete the [{tag}] tag from the [{name}] Docker image? The following tags [{tagsWithSameDigest}] will also be deleted because they share the same digest.",
    "removeSubTitleWhenTagWithSameDigest": "Are you sure you want to delete the [{tag}] tag from the [{name}] Docker image? The tag [{tagWithSameDigest}] will also be deleted because it shares the same digest."
  },
  "rateLimit": {
    "tooManyRequests": "Too many requests"
  }
}